{
  "id": "atlantis-rising",
  "name": "Atlantis Rising",
  "addedOn": "2026-10-27",
  "backgroundImage": "atlantis-rising",
  "opaqueTerritoryFills": true,
  "hideAdjacencyLines": true,
  "viewBox": {
    "x": 0,
    "y": 0,
    "width": 1150,
    "height": 800
  },
  "selectionInnerGlow": true,
  "backdropColor": {
    "light": "#d4e3e6",
    "dark": "#26403f",
    "topBar": true
  },
  "gameLayout": {
    "playerBarPosition": "right"
  },
  "edgeConfig": {
    "internalBorderWidth": 0,
    "regionBorderWidth": 10.1,
    "bridgeStrokeWidth": 0
  },
  "wraparoundAdjacencies": [
    [
      "bathysphere",
      "periscope-post"
    ],
    [
      "gullwater",
      "spongebed"
    ]
  ],
  "regions": [
    {
      "id": "sunlit-shallows",
      "name": "Sunlit Shallows",
      "bonus": 7,
      "shape": "M 118 100 L 118.02 98.63 L 118.09 97.25 L 118.2 95.88 L 118.36 94.52 L 118.56 93.16 L 118.81 91.81 L 119.1 90.46 L 119.43 89.13 L 119.81 87.81 L 120.23 86.5 L 120.69 85.21 L 121.2 83.93 L 121.74 82.67 L 122.33 81.42 L 122.96 80.2 L 123.63 79 L 124.33 77.82 L 125.08 76.67 L 125.86 75.54 L 126.68 74.43 L 127.53 73.36 L 128.42 72.31 L 129.35 71.29 L 130.3 70.3 L 131.29 69.35 L 132.31 68.42 L 133.36 67.53 L 134.43 66.68 L 135.54 65.86 L 136.67 65.08 L 137.82 64.33 L 139 63.63 L 140.2 62.96 L 141.42 62.33 L 142.67 61.74 L 143.93 61.2 L 145.21 60.69 L 146.5 60.23 L 147.81 59.81 L 149.13 59.43 L 150.46 59.1 L 151.81 58.81 L 153.16 58.56 L 154.52 58.36 L 155.88 58.2 L 157.25 58.09 L 158.63 58.02 L 160 58 L 161.37 58.02 L 162.75 58.09 L 164.12 58.2 L 165.48 58.36 L 166.84 58.56 L 168.19 58.81 L 169.54 59.1 L 170.87 59.43 L 172.19 59.81 L 173.5 60.23 L 174.79 60.69 L 176.07 61.2 L 177.33 61.74 L 178.58 62.33 L 179.8 62.96 L 250 101.96 L 320.2 62.96 L 321.42 62.33 L 322.67 61.74 L 323.93 61.2 L 325.21 60.69 L 326.5 60.23 L 327.81 59.81 L 329.13 59.43 L 330.46 59.1 L 331.81 58.81 L 333.16 58.56 L 334.52 58.36 L 335.88 58.2 L 337.25 58.09 L 338.63 58.02 L 340 58 L 341.37 58.02 L 342.75 58.09 L 344.12 58.2 L 345.48 58.36 L 346.84 58.56 L 348.19 58.81 L 349.54 59.1 L 350.87 59.43 L 352.19 59.81 L 353.5 60.23 L 354.79 60.69 L 356.07 61.2 L 357.33 61.74 L 358.58 62.33 L 359.8 62.96 L 361 63.63 L 362.18 64.33 L 363.33 65.08 L 364.46 65.86 L 365.57 66.68 L 366.64 67.53 L 367.69 68.42 L 368.71 69.35 L 369.7 70.3 L 370.65 71.29 L 371.58 72.31 L 372.47 73.36 L 373.32 74.43 L 374.14 75.54 L 374.92 76.67 L 375.67 77.82 L 376.37 79 L 377.04 80.2 L 377.67 81.42 L 378.26 82.67 L 378.8 83.93 L 379.31 85.21 L 379.77 86.5 L 380.19 87.81 L 380.57 89.13 L 380.9 90.46 L 381 90.93 L 381.19 91.81 L 381.44 93.16 L 381.64 94.52 L 381.8 95.88 L 381.91 97.25 L 381.98 98.63 L 382 100 L 381.98 101.37 L 381.91 102.75 L 381.8 104.12 L 381.64 105.48 L 381.44 106.84 L 381.19 108.19 L 381 109.07 L 381 190.93 L 381.19 191.81 L 381.44 193.16 L 381.64 194.52 L 381.8 195.88 L 381.91 197.25 L 381.98 198.63 L 382 200 L 381.98 201.37 L 381.91 202.75 L 381.8 204.12 L 381.64 205.48 L 381.44 206.84 L 381.19 208.19 L 381 209.07 L 381 290.93 L 381.19 291.81 L 381.44 293.16 L 381.64 294.52 L 381.8 295.88 L 381.91 297.25 L 381.98 298.63 L 382 300 L 381.98 301.37 L 381.91 302.75 L 381.8 304.12 L 381.64 305.48 L 381.44 306.84 L 381.19 308.19 L 381 309.07 L 380.9 309.54 L 380.57 310.87 L 380.19 312.19 L 379.77 313.5 L 379.31 314.79 L 378.8 316.07 L 378.26 317.33 L 377.67 318.58 L 377.04 319.8 L 376.37 321 L 375.67 322.18 L 374.92 323.33 L 374.14 324.46 L 373.49 325.34 L 373.32 325.57 L 372.47 326.64 L 371.58 327.69 L 370.65 328.71 L 369.7 329.7 L 368.71 330.65 L 367.69 331.58 L 366.64 332.47 L 365.57 333.32 L 364.46 334.14 L 363.33 334.92 L 362.18 335.67 L 361 336.37 L 359.8 337.04 L 358.58 337.67 L 357.33 338.26 L 356.07 338.8 L 354.79 339.31 L 353.5 339.77 L 352.19 340.19 L 350.87 340.57 L 349.54 340.9 L 348.19 341.19 L 346.84 341.44 L 345.48 341.64 L 344.12 341.8 L 343.82 341.82 L 283.49 375.34 L 283.32 375.57 L 282.47 376.64 L 281.58 377.69 L 280.65 378.71 L 279.7 379.7 L 278.71 380.65 L 277.69 381.58 L 276.64 382.47 L 275.57 383.32 L 274.46 384.14 L 273.33 384.92 L 272.18 385.67 L 271 386.37 L 269.8 387.04 L 268.58 387.67 L 267.33 388.26 L 266.07 388.8 L 264.79 389.31 L 263.5 389.77 L 262.19 390.19 L 260.87 390.57 L 259.54 390.9 L 258.19 391.19 L 256.84 391.44 L 255.48 391.64 L 254.12 391.8 L 252.75 391.91 L 251.37 391.98 L 250 392 L 248.63 391.98 L 247.25 391.91 L 246.18 391.82 L 245.88 391.8 L 244.52 391.64 L 243.16 391.44 L 241.81 391.19 L 240.46 390.9 L 239.13 390.57 L 237.81 390.19 L 236.5 389.77 L 235.21 389.31 L 233.93 388.8 L 232.67 388.26 L 231.42 387.67 L 230.2 387.04 L 229 386.37 L 227.82 385.67 L 226.67 384.92 L 225.54 384.14 L 224.43 383.32 L 223.36 382.47 L 222.31 381.58 L 221.29 380.65 L 220.3 379.7 L 219.35 378.71 L 218.42 377.69 L 217.53 376.64 L 216.68 375.57 L 216.51 375.34 L 156.18 341.82 L 155.88 341.8 L 154.52 341.64 L 153.16 341.44 L 151.81 341.19 L 150.46 340.9 L 149.13 340.57 L 147.81 340.19 L 146.5 339.77 L 145.21 339.31 L 143.93 338.8 L 142.67 338.26 L 141.42 337.67 L 140.2 337.04 L 139 336.37 L 137.82 335.67 L 136.67 334.92 L 135.54 334.14 L 134.43 333.32 L 133.36 332.47 L 132.31 331.58 L 131.29 330.65 L 130.3 329.7 L 129.35 328.71 L 128.42 327.69 L 127.53 326.64 L 126.68 325.57 L 126.51 325.34 L 126.51 325.34 L 125.86 324.46 L 125.08 323.33 L 124.33 322.18 L 123.63 321 L 122.96 319.8 L 122.33 318.58 L 121.74 317.33 L 121.2 316.07 L 120.69 314.79 L 120.23 313.5 L 119.81 312.19 L 119.43 310.87 L 119.1 309.54 L 119 309.07 L 118.81 308.19 L 118.56 306.84 L 118.36 305.48 L 118.2 304.12 L 118.09 302.75 L 118.02 301.37 L 118 300 L 118.02 298.63 L 118.09 297.25 L 118.2 295.88 L 118.36 294.52 L 118.56 293.16 L 118.81 291.81 L 119 290.93 L 119 209.07 L 118.81 208.19 L 118.56 206.84 L 118.36 205.48 L 118.2 204.12 L 118.09 202.75 L 118.02 201.37 L 118 200 Z",
      "territoryIds": [
        "brinehaven",
        "driftwood-banks",
        "gullwater",
        "kelpgate",
        "pelican-reach",
        "saltmeadow",
        "sandbar-hold",
        "shellcove",
        "tidecrest"
      ],
      "color": "#F2C94C",
      "bonusAnchor": {
        "x": 249.81,
        "y": 199.02
      }
    },
    {
      "id": "abyssal-spires",
      "name": "Abyssal Spires",
      "bonus": 5,
      "shape": "M 388 150 L 388.02 148.63 L 388.09 147.25 L 388.2 145.88 L 388.36 144.52 L 388.56 143.16 L 388.81 141.81 L 389.1 140.46 L 389.43 139.13 L 389.81 137.81 L 390.23 136.5 L 390.69 135.21 L 391.2 133.93 L 391.74 132.67 L 392.33 131.42 L 392.96 130.2 L 393.63 129 L 394.33 127.82 L 395.08 126.67 L 395.86 125.54 L 396.68 124.43 L 397.53 123.36 L 398.42 122.31 L 399.35 121.29 L 400.3 120.3 L 401.29 119.35 L 402.31 118.42 L 403.36 117.53 L 404.43 116.68 L 405.54 115.86 L 406.67 115.08 L 407.82 114.33 L 409 113.63 L 410.2 112.96 L 590.2 12.96 L 591.42 12.33 L 592.67 11.74 L 593.93 11.2 L 595.21 10.69 L 596.5 10.23 L 597.81 9.81 L 599.13 9.43 L 600.46 9.1 L 601.81 8.81 L 603.16 8.56 L 604.52 8.36 L 605.88 8.2 L 607.25 8.09 L 608.63 8.02 L 610 8 L 611.37 8.02 L 612.75 8.09 L 614.12 8.2 L 615.48 8.36 L 616.84 8.56 L 618.19 8.81 L 619.54 9.1 L 620.87 9.43 L 622.19 9.81 L 623.5 10.23 L 624.79 10.69 L 626.07 11.2 L 627.33 11.74 L 628.58 12.33 L 629.8 12.96 L 631 13.63 L 632.18 14.33 L 633.33 15.08 L 634.46 15.86 L 635.57 16.68 L 636.64 17.53 L 637.69 18.42 L 638.71 19.35 L 639.7 20.3 L 640.65 21.29 L 641.58 22.31 L 642.47 23.36 L 643.32 24.43 L 644.14 25.54 L 644.92 26.67 L 645.67 27.82 L 735.67 177.82 L 736.37 179 L 737.04 180.2 L 737.67 181.42 L 738.26 182.67 L 738.8 183.93 L 739.31 185.21 L 739.77 186.5 L 740.19 187.81 L 740.57 189.13 L 740.9 190.46 L 741.19 191.81 L 741.44 193.16 L 741.64 194.52 L 741.8 195.88 L 741.91 197.25 L 741.98 198.63 L 742 200 L 741.98 201.37 L 741.91 202.75 L 741.8 204.12 L 741.64 205.48 L 741.44 206.84 L 741.19 208.19 L 740.9 209.54 L 740.57 210.87 L 740.19 212.19 L 739.77 213.5 L 739.31 214.79 L 738.8 216.07 L 738.26 217.33 L 737.67 218.58 L 737.04 219.8 L 736.37 221 L 735.67 222.18 L 734.92 223.33 L 734.14 224.46 L 733.49 225.34 L 733.32 225.57 L 732.47 226.64 L 731.58 227.69 L 730.65 228.71 L 729.7 229.7 L 728.71 230.65 L 727.69 231.58 L 726.64 232.47 L 725.57 233.32 L 724.46 234.14 L 723.33 234.92 L 722.18 235.67 L 721 236.37 L 719.8 237.04 L 718.58 237.67 L 717.33 238.26 L 716.07 238.8 L 714.79 239.31 L 713.5 239.77 L 712.19 240.19 L 710.87 240.57 L 709.54 240.9 L 708.19 241.19 L 706.84 241.44 L 705.48 241.64 L 704.12 241.8 L 703.82 241.82 L 643.49 275.34 L 643.32 275.57 L 642.47 276.64 L 641.58 277.69 L 640.65 278.71 L 639.7 279.7 L 638.71 280.65 L 637.69 281.58 L 636.64 282.47 L 635.57 283.32 L 634.46 284.14 L 633.33 284.92 L 632.18 285.67 L 631 286.37 L 629.8 287.04 L 628.58 287.67 L 627.33 288.26 L 626.07 288.8 L 624.79 289.31 L 623.5 289.77 L 622.19 290.19 L 620.87 290.57 L 619.54 290.9 L 618.19 291.19 L 616.84 291.44 L 615.48 291.64 L 614.12 291.8 L 613.82 291.82 L 553.49 325.34 L 553.32 325.57 L 552.47 326.64 L 551.58 327.69 L 550.65 328.71 L 549.7 329.7 L 548.71 330.65 L 547.69 331.58 L 546.64 332.47 L 545.57 333.32 L 544.46 334.14 L 543.33 334.92 L 542.18 335.67 L 541 336.37 L 539.8 337.04 L 538.58 337.67 L 537.33 338.26 L 536.07 338.8 L 534.79 339.31 L 533.5 339.77 L 532.19 340.19 L 530.87 340.57 L 529.54 340.9 L 528.19 341.19 L 526.84 341.44 L 525.48 341.64 L 524.12 341.8 L 523.82 341.82 L 522.75 341.91 L 521.37 341.98 L 520 342 L 518.63 341.98 L 517.25 341.91 L 515.88 341.8 L 514.52 341.64 L 513.16 341.44 L 511.81 341.19 L 510.46 340.9 L 509.13 340.57 L 507.81 340.19 L 506.5 339.77 L 505.21 339.31 L 503.93 338.8 L 502.67 338.26 L 501.42 337.67 L 500.2 337.04 L 499 336.37 L 497.82 335.67 L 496.67 334.92 L 495.54 334.14 L 494.43 333.32 L 493.36 332.47 L 492.31 331.58 L 491.29 330.65 L 490.3 329.7 L 489.35 328.71 L 488.42 327.69 L 487.53 326.64 L 486.68 325.57 L 485.86 324.46 L 485.08 323.33 L 484.33 322.18 L 483.63 321 L 482.96 319.8 L 482.33 318.58 L 481.74 317.33 L 481.2 316.07 L 480.69 314.79 L 480.23 313.5 L 479.81 312.19 L 479.43 310.87 L 479.1 309.54 L 479 309.07 L 478.81 308.19 L 478.56 306.84 L 478.36 305.48 L 478.2 304.12 L 478.09 302.75 L 478.02 301.37 L 478 300 L 478.02 298.63 L 478.09 297.25 L 478.2 295.88 L 478.36 294.52 L 478.56 293.16 L 478.81 291.81 L 479 290.93 L 479 221.17 L 426.18 191.82 L 425.88 191.8 L 424.52 191.64 L 423.16 191.44 L 421.81 191.19 L 420.46 190.9 L 419.13 190.57 L 417.81 190.19 L 416.5 189.77 L 415.21 189.31 L 413.93 188.8 L 412.67 188.26 L 411.42 187.67 L 410.2 187.04 L 409 186.37 L 407.82 185.67 L 406.67 184.92 L 405.54 184.14 L 404.43 183.32 L 403.36 182.47 L 402.31 181.58 L 401.29 180.65 L 400.3 179.7 L 399.35 178.71 L 398.42 177.69 L 397.53 176.64 L 396.68 175.57 L 396.51 175.34 L 396.51 175.34 L 395.86 174.46 L 395.08 173.33 L 394.33 172.18 L 393.63 171 L 392.96 169.8 L 392.33 168.58 L 391.74 167.33 L 391.2 166.07 L 390.69 164.79 L 390.23 163.5 L 389.81 162.19 L 389.43 160.87 L 389.1 159.54 L 388.81 158.19 L 388.56 156.84 L 388.36 155.48 L 388.2 154.12 L 388.09 152.75 L 388.02 151.37 Z",
      "territoryIds": [
        "blackvent",
        "gloomspire",
        "inkwell",
        "lanternfish-deep",
        "nightcoral",
        "pressure-gate",
        "squidhollow"
      ],
      "color": "#9B5CFF",
      "bonusAnchor": {
        "x": 531.12,
        "y": 124.26
      }
    },
    {
      "id": "staghorn-reach",
      "name": "Staghorn Reach",
      "bonus": 4,
      "shape": "M 658 300 L 658.02 298.63 L 658.09 297.25 L 658.2 295.88 L 658.36 294.52 L 658.56 293.16 L 658.81 291.81 L 659.1 290.46 L 659.43 289.13 L 659.81 287.81 L 660.23 286.5 L 660.69 285.21 L 661.2 283.93 L 661.74 282.67 L 662.33 281.42 L 662.96 280.2 L 663.63 279 L 664.33 277.82 L 665.08 276.67 L 665.86 275.54 L 666.51 274.66 L 666.51 274.66 L 666.68 274.43 L 667.53 273.36 L 668.42 272.31 L 669.35 271.29 L 670.3 270.3 L 671.29 269.35 L 672.31 268.42 L 673.36 267.53 L 674.43 266.68 L 675.54 265.86 L 676.67 265.08 L 677.82 264.33 L 679 263.63 L 680.2 262.96 L 681.42 262.33 L 682.67 261.74 L 683.93 261.2 L 685.21 260.69 L 686.5 260.23 L 687.81 259.81 L 689.13 259.43 L 690.46 259.1 L 691.81 258.81 L 693.16 258.56 L 694.52 258.36 L 695.88 258.2 L 696.18 258.18 L 749 228.83 L 749 159.07 L 748.81 158.19 L 748.56 156.84 L 748.36 155.48 L 748.2 154.12 L 748.09 152.75 L 748.02 151.37 L 748 150 L 748.02 148.63 L 748.09 147.25 L 748.2 145.88 L 748.36 144.52 L 748.56 143.16 L 748.81 141.81 L 749 140.93 L 749.1 140.46 L 749.43 139.13 L 749.81 137.81 L 750.23 136.5 L 750.69 135.21 L 751.2 133.93 L 751.74 132.67 L 752.33 131.42 L 752.96 130.2 L 753.63 129 L 754.33 127.82 L 755.08 126.67 L 755.86 125.54 L 756.68 124.43 L 757.53 123.36 L 758.42 122.31 L 759.35 121.29 L 760.3 120.3 L 761.29 119.35 L 762.31 118.42 L 763.36 117.53 L 764.43 116.68 L 765.54 115.86 L 766.67 115.08 L 767.82 114.33 L 769 113.63 L 770.2 112.96 L 771.42 112.33 L 772.67 111.74 L 773.93 111.2 L 775.21 110.69 L 776.5 110.23 L 777.81 109.81 L 779.13 109.43 L 780.46 109.1 L 781.81 108.81 L 783.16 108.56 L 784.52 108.36 L 785.88 108.2 L 787.25 108.09 L 788.63 108.02 L 790 108 L 791.37 108.02 L 792.75 108.09 L 794.12 108.2 L 795.48 108.36 L 796.84 108.56 L 798.19 108.81 L 799.54 109.1 L 800.87 109.43 L 802.19 109.81 L 803.5 110.23 L 804.79 110.69 L 806.07 111.2 L 807.33 111.74 L 808.58 112.33 L 809.8 112.96 L 811 113.63 L 812.18 114.33 L 813.33 115.08 L 814.46 115.86 L 815.57 116.68 L 816.64 117.53 L 817.69 118.42 L 818.71 119.35 L 819.7 120.3 L 820.65 121.29 L 821.58 122.31 L 822.47 123.36 L 823.32 124.43 L 824.14 125.54 L 824.92 126.67 L 825.67 127.82 L 826.37 129 L 827.04 130.2 L 827.67 131.42 L 828.26 132.67 L 828.8 133.93 L 829.31 135.21 L 829.77 136.5 L 830.19 137.81 L 830.57 139.13 L 830.9 140.46 L 831 140.93 L 831.19 141.81 L 831.44 143.16 L 831.64 144.52 L 831.8 145.88 L 831.91 147.25 L 831.98 148.63 L 832 150 L 831.98 151.37 L 831.91 152.75 L 831.8 154.12 L 831.64 155.48 L 831.44 156.84 L 831.19 158.19 L 831 159.07 L 831 213.57 L 844.73 236.46 L 883.82 258.18 L 884.12 258.2 L 885.48 258.36 L 886.84 258.56 L 888.19 258.81 L 889.54 259.1 L 890.87 259.43 L 892.19 259.81 L 893.5 260.23 L 894.79 260.69 L 896.07 261.2 L 897.33 261.74 L 898.58 262.33 L 899.8 262.96 L 901 263.63 L 902.18 264.33 L 903.33 265.08 L 904.46 265.86 L 905.57 266.68 L 906.64 267.53 L 907.69 268.42 L 908.71 269.35 L 909.7 270.3 L 910.65 271.29 L 911.58 272.31 L 912.47 273.36 L 913.32 274.43 L 913.49 274.66 L 914.14 275.54 L 914.92 276.67 L 915.67 277.82 L 916.37 279 L 917.04 280.2 L 917.67 281.42 L 918.26 282.67 L 918.8 283.93 L 919.31 285.21 L 919.77 286.5 L 920.19 287.81 L 920.57 289.13 L 920.9 290.46 L 921 290.93 L 921.19 291.81 L 921.44 293.16 L 921.64 294.52 L 921.8 295.88 L 921.91 297.25 L 921.98 298.63 L 922 300 L 921.98 301.37 L 921.91 302.75 L 921.8 304.12 L 921.64 305.48 L 921.44 306.84 L 921.19 308.19 L 921 309.07 L 921 390.93 L 921.19 391.81 L 921.44 393.16 L 921.64 394.52 L 921.8 395.88 L 921.91 397.25 L 921.98 398.63 L 922 400 L 921.98 401.37 L 921.91 402.75 L 921.8 404.12 L 921.64 405.48 L 921.44 406.84 L 921.19 408.19 L 921 409.07 L 920.9 409.54 L 920.57 410.87 L 920.19 412.19 L 919.77 413.5 L 919.31 414.79 L 918.8 416.07 L 918.26 417.33 L 917.67 418.58 L 917.04 419.8 L 916.37 421 L 915.67 422.18 L 914.92 423.33 L 914.14 424.46 L 913.32 425.57 L 912.47 426.64 L 911.58 427.69 L 910.65 428.71 L 909.7 429.7 L 908.71 430.65 L 907.69 431.58 L 906.64 432.47 L 905.57 433.32 L 904.46 434.14 L 903.33 434.92 L 902.18 435.67 L 901 436.37 L 899.8 437.04 L 898.58 437.67 L 897.33 438.26 L 896.07 438.8 L 894.79 439.31 L 893.5 439.77 L 892.19 440.19 L 890.87 440.57 L 889.54 440.9 L 888.19 441.19 L 886.84 441.44 L 885.48 441.64 L 884.12 441.8 L 882.75 441.91 L 881.37 441.98 L 880 442 L 878.63 441.98 L 877.25 441.91 L 876.18 441.82 L 875.88 441.8 L 874.52 441.64 L 873.16 441.44 L 871.81 441.19 L 870.46 440.9 L 869.13 440.57 L 867.81 440.19 L 866.5 439.77 L 865.21 439.31 L 863.93 438.8 L 862.67 438.26 L 861.42 437.67 L 860.2 437.04 L 859 436.37 L 857.82 435.67 L 856.67 434.92 L 855.54 434.14 L 854.43 433.32 L 853.36 432.47 L 852.31 431.58 L 851.29 430.65 L 850.3 429.7 L 849.35 428.71 L 848.42 427.69 L 847.53 426.64 L 846.68 425.57 L 846.51 425.34 L 786.18 391.82 L 786.18 391.82 L 785.88 391.8 L 784.52 391.64 L 783.16 391.44 L 781.81 391.19 L 780.46 390.9 L 779.13 390.57 L 777.81 390.19 L 776.5 389.77 L 775.21 389.31 L 773.93 388.8 L 772.67 388.26 L 771.42 387.67 L 770.2 387.04 L 769 386.37 L 767.82 385.67 L 766.67 384.92 L 765.54 384.14 L 764.43 383.32 L 763.36 382.47 L 762.31 381.58 L 761.29 380.65 L 760.3 379.7 L 759.35 378.71 L 758.42 377.69 L 757.53 376.64 L 756.68 375.57 L 756.51 375.34 L 696.18 341.82 L 695.88 341.8 L 694.52 341.64 L 693.16 341.44 L 691.81 341.19 L 690.46 340.9 L 689.13 340.57 L 687.81 340.19 L 686.5 339.77 L 685.21 339.31 L 683.93 338.8 L 682.67 338.26 L 681.42 337.67 L 680.2 337.04 L 679 336.37 L 677.82 335.67 L 676.67 334.92 L 675.54 334.14 L 674.43 333.32 L 673.36 332.47 L 672.31 331.58 L 671.29 330.65 L 670.3 329.7 L 669.35 328.71 L 668.42 327.69 L 667.53 326.64 L 666.68 325.57 L 666.51 325.34 L 666.51 325.34 L 665.86 324.46 L 665.08 323.33 L 664.33 322.18 L 663.63 321 L 662.96 319.8 L 662.33 318.58 L 661.74 317.33 L 661.2 316.07 L 660.69 314.79 L 660.23 313.5 L 659.81 312.19 L 659.43 310.87 L 659.1 309.54 L 658.81 308.19 L 658.56 306.84 L 658.36 305.48 L 658.2 304.12 L 658.09 302.75 L 658.02 301.37 Z",
      "territoryIds": [
        "anemone-fields",
        "brainreef",
        "clownfish-bay",
        "fanwall",
        "seafan-ridge",
        "staghorn"
      ],
      "color": "#FF7F27",
      "bonusAnchor": {
        "x": 818.36,
        "y": 298.25
      }
    },
    {
      "id": "coral-dominion",
      "name": "Coral Dominion",
      "bonus": 4,
      "shape": "M 838 100 L 838.02 98.63 L 838.09 97.25 L 838.2 95.88 L 838.36 94.52 L 838.56 93.16 L 838.81 91.81 L 839 90.93 L 839.1 90.46 L 839.43 89.13 L 839.81 87.81 L 840.23 86.5 L 840.69 85.21 L 841.2 83.93 L 841.74 82.67 L 842.33 81.42 L 842.96 80.2 L 843.63 79 L 844.33 77.82 L 845.08 76.67 L 845.86 75.54 L 846.68 74.43 L 847.53 73.36 L 848.42 72.31 L 849.35 71.29 L 850.3 70.3 L 851.29 69.35 L 852.31 68.42 L 853.36 67.53 L 854.43 66.68 L 855.54 65.86 L 856.67 65.08 L 857.82 64.33 L 859 63.63 L 860.2 62.96 L 861.42 62.33 L 862.67 61.74 L 863.93 61.2 L 865.21 60.69 L 866.5 60.23 L 867.81 59.81 L 869.13 59.43 L 870.46 59.1 L 871.81 58.81 L 873.16 58.56 L 874.52 58.36 L 875.88 58.2 L 877.25 58.09 L 878.63 58.02 L 880 58 L 1060 58 L 1061.37 58.02 L 1062.75 58.09 L 1064.12 58.2 L 1065.48 58.36 L 1066.84 58.56 L 1068.19 58.81 L 1069.54 59.1 L 1070.87 59.43 L 1072.19 59.81 L 1073.5 60.23 L 1074.79 60.69 L 1076.07 61.2 L 1077.33 61.74 L 1078.58 62.33 L 1079.8 62.96 L 1081 63.63 L 1082.18 64.33 L 1083.33 65.08 L 1084.46 65.86 L 1085.57 66.68 L 1086.64 67.53 L 1087.69 68.42 L 1088.71 69.35 L 1089.7 70.3 L 1090.65 71.29 L 1091.58 72.31 L 1092.47 73.36 L 1093.32 74.43 L 1094.14 75.54 L 1094.92 76.67 L 1095.67 77.82 L 1096.37 79 L 1097.04 80.2 L 1097.67 81.42 L 1098.26 82.67 L 1098.8 83.93 L 1099.31 85.21 L 1099.77 86.5 L 1100.19 87.81 L 1100.57 89.13 L 1100.9 90.46 L 1101.19 91.81 L 1101.44 93.16 L 1101.64 94.52 L 1101.8 95.88 L 1101.91 97.25 L 1101.98 98.63 L 1102 100 L 1102 300 L 1101.98 301.37 L 1101.91 302.75 L 1101.8 304.12 L 1101.64 305.48 L 1101.44 306.84 L 1101.19 308.19 L 1100.9 309.54 L 1100.57 310.87 L 1100.19 312.19 L 1099.77 313.5 L 1099.31 314.79 L 1098.8 316.07 L 1098.26 317.33 L 1097.67 318.58 L 1097.04 319.8 L 1096.37 321 L 1095.67 322.18 L 1094.92 323.33 L 1094.14 324.46 L 1093.32 325.57 L 1092.47 326.64 L 1091.58 327.69 L 1090.65 328.71 L 1089.7 329.7 L 1088.71 330.65 L 1087.69 331.58 L 1086.64 332.47 L 1085.57 333.32 L 1084.46 334.14 L 1083.33 334.92 L 1082.18 335.67 L 1081 336.37 L 1079.8 337.04 L 1078.58 337.67 L 1077.33 338.26 L 1076.07 338.8 L 1074.79 339.31 L 1073.5 339.77 L 1072.19 340.19 L 1070.87 340.57 L 1069.54 340.9 L 1068.19 341.19 L 1066.84 341.44 L 1065.48 341.64 L 1064.12 341.8 L 1062.75 341.91 L 1061.37 341.98 L 1060 342 L 1058.63 341.98 L 1057.25 341.91 L 1056.18 341.82 L 1055.88 341.8 L 1054.52 341.64 L 1053.16 341.44 L 1051.81 341.19 L 1050.46 340.9 L 1049.13 340.57 L 1047.81 340.19 L 1046.5 339.77 L 1045.21 339.31 L 1043.93 338.8 L 1042.67 338.26 L 1041.42 337.67 L 1040.2 337.04 L 1039 336.37 L 1037.82 335.67 L 1036.67 334.92 L 1035.54 334.14 L 1034.43 333.32 L 1033.36 332.47 L 1032.31 331.58 L 1031.29 330.65 L 1030.3 329.7 L 1029.35 328.71 L 1028.42 327.69 L 1027.53 326.64 L 1026.68 325.57 L 1026.51 325.34 L 966.18 291.82 L 966.18 291.82 L 965.88 291.8 L 964.52 291.64 L 963.16 291.44 L 961.81 291.19 L 960.46 290.9 L 959.13 290.57 L 957.81 290.19 L 956.5 289.77 L 955.21 289.31 L 953.93 288.8 L 952.67 288.26 L 951.42 287.67 L 950.2 287.04 L 949 286.37 L 947.82 285.67 L 946.67 284.92 L 945.54 284.14 L 944.43 283.32 L 943.36 282.47 L 942.31 281.58 L 941.29 280.65 L 940.3 279.7 L 939.35 278.71 L 938.42 277.69 L 937.53 276.64 L 936.68 275.57 L 936.51 275.34 L 876.18 241.82 L 875.88 241.8 L 874.52 241.64 L 873.16 241.44 L 871.81 241.19 L 870.46 240.9 L 869.13 240.57 L 867.81 240.19 L 866.5 239.77 L 865.21 239.31 L 863.93 238.8 L 862.67 238.26 L 861.42 237.67 L 860.2 237.04 L 859 236.37 L 857.82 235.67 L 856.67 234.92 L 855.54 234.14 L 854.43 233.32 L 853.36 232.47 L 852.31 231.58 L 851.29 230.65 L 850.3 229.7 L 849.35 228.71 L 848.42 227.69 L 847.53 226.64 L 846.68 225.57 L 846.51 225.34 L 846.51 225.34 L 845.86 224.46 L 845.08 223.33 L 844.33 222.18 L 843.63 221 L 842.96 219.8 L 842.33 218.58 L 841.74 217.33 L 841.2 216.07 L 840.69 214.79 L 840.23 213.5 L 839.81 212.19 L 839.43 210.87 L 839.1 209.54 L 839 209.07 L 838.81 208.19 L 838.56 206.84 L 838.36 205.48 L 838.2 204.12 L 838.09 202.75 L 838.02 201.37 L 838 200 L 838.02 198.63 L 838.09 197.25 L 838.2 195.88 L 838.36 194.52 L 838.56 193.16 L 838.81 191.81 L 839 190.93 L 839 109.07 L 838.81 108.19 L 838.56 106.84 L 838.36 105.48 L 838.2 104.12 L 838.09 102.75 L 838.02 101.37 Z",
      "territoryIds": [
        "lagoon-throne",
        "mantle-reef",
        "parrotfish-point",
        "polyp-gardens",
        "spongebed",
        "urchin-march"
      ],
      "color": "#D81B60",
      "bonusAnchor": {
        "x": 1025.41,
        "y": 187.29
      }
    },
    {
      "id": "ember-rift",
      "name": "Ember Rift",
      "bonus": 2,
      "shape": "M 208 450 L 208.02 448.63 L 208.09 447.25 L 208.2 445.88 L 208.36 444.52 L 208.56 443.16 L 208.81 441.81 L 209.1 440.46 L 209.43 439.13 L 209.81 437.81 L 210.23 436.5 L 210.69 435.21 L 211.2 433.93 L 211.74 432.67 L 212.33 431.42 L 212.96 430.2 L 213.63 429 L 214.33 427.82 L 215.08 426.67 L 215.86 425.54 L 216.68 424.43 L 217.53 423.36 L 218.42 422.31 L 219.35 421.29 L 220.3 420.3 L 221.29 419.35 L 222.31 418.42 L 223.36 417.53 L 224.43 416.68 L 225.54 415.86 L 226.67 415.08 L 227.82 414.33 L 229 413.63 L 230.2 412.96 L 231.42 412.33 L 232.67 411.74 L 233.93 411.2 L 235.21 410.69 L 236.5 410.23 L 237.81 409.81 L 239.13 409.43 L 240.46 409.1 L 241.81 408.81 L 243.16 408.56 L 244.52 408.36 L 245.88 408.2 L 247.25 408.09 L 248.63 408.02 L 250 408 L 251.37 408.02 L 252.75 408.09 L 253.82 408.18 L 253.82 408.18 L 254.12 408.2 L 255.48 408.36 L 256.84 408.56 L 258.19 408.81 L 259.54 409.1 L 260.87 409.43 L 262.19 409.81 L 263.5 410.23 L 264.79 410.69 L 266.07 411.2 L 267.33 411.74 L 268.58 412.33 L 269.8 412.96 L 271 413.63 L 272.18 414.33 L 273.33 415.08 L 274.46 415.86 L 275.57 416.68 L 276.64 417.53 L 277.69 418.42 L 278.71 419.35 L 279.7 420.3 L 280.65 421.29 L 281.58 422.31 L 282.47 423.36 L 283.32 424.43 L 283.49 424.66 L 343.82 458.18 L 344.12 458.2 L 345.48 458.36 L 346.84 458.56 L 348.19 458.81 L 349.54 459.1 L 350.87 459.43 L 352.19 459.81 L 353.5 460.23 L 354.79 460.69 L 356.07 461.2 L 357.33 461.74 L 358.58 462.33 L 359.8 462.96 L 361 463.63 L 362.18 464.33 L 363.33 465.08 L 364.46 465.86 L 365.57 466.68 L 366.64 467.53 L 367.69 468.42 L 368.71 469.35 L 369.7 470.3 L 370.65 471.29 L 371.58 472.31 L 372.47 473.36 L 373.32 474.43 L 373.49 474.66 L 374.14 475.54 L 374.92 476.67 L 375.67 477.82 L 376.37 479 L 377.04 480.2 L 377.67 481.42 L 378.26 482.67 L 378.8 483.93 L 379.31 485.21 L 379.77 486.5 L 380.19 487.81 L 380.57 489.13 L 380.9 490.46 L 381 490.93 L 381.19 491.81 L 381.44 493.16 L 381.64 494.52 L 381.8 495.88 L 381.91 497.25 L 381.98 498.63 L 382 500 L 381.98 501.37 L 381.91 502.75 L 381.8 504.12 L 381.64 505.48 L 381.44 506.84 L 381.19 508.19 L 381 509.07 L 381 590.93 L 381.19 591.81 L 381.44 593.16 L 381.64 594.52 L 381.8 595.88 L 381.91 597.25 L 381.98 598.63 L 382 600 L 381.98 601.37 L 381.91 602.75 L 381.8 604.12 L 381.64 605.48 L 381.44 606.84 L 381.19 608.19 L 381 609.07 L 380.9 609.54 L 380.57 610.87 L 380.19 612.19 L 379.77 613.5 L 379.31 614.79 L 378.8 616.07 L 378.26 617.33 L 377.67 618.58 L 377.04 619.8 L 376.37 621 L 375.67 622.18 L 374.92 623.33 L 374.14 624.46 L 373.32 625.57 L 372.47 626.64 L 371.58 627.69 L 370.65 628.71 L 369.7 629.7 L 368.71 630.65 L 367.69 631.58 L 366.64 632.47 L 365.57 633.32 L 364.46 634.14 L 363.33 634.92 L 362.18 635.67 L 361 636.37 L 359.8 637.04 L 358.58 637.67 L 357.33 638.26 L 356.07 638.8 L 354.79 639.31 L 353.5 639.77 L 352.19 640.19 L 350.87 640.57 L 349.54 640.9 L 348.19 641.19 L 346.84 641.44 L 345.48 641.64 L 344.12 641.8 L 342.75 641.91 L 341.37 641.98 L 340 642 L 338.63 641.98 L 337.25 641.91 L 335.88 641.8 L 334.52 641.64 L 333.16 641.44 L 331.81 641.19 L 330.46 640.9 L 329.13 640.57 L 327.81 640.19 L 326.5 639.77 L 325.21 639.31 L 323.93 638.8 L 322.67 638.26 L 321.42 637.67 L 320.2 637.04 L 230.2 587.04 L 229 586.37 L 227.82 585.67 L 226.67 584.92 L 225.54 584.14 L 224.43 583.32 L 223.36 582.47 L 222.31 581.58 L 221.29 580.65 L 220.3 579.7 L 219.35 578.71 L 218.42 577.69 L 217.53 576.64 L 216.68 575.57 L 215.86 574.46 L 215.08 573.33 L 214.33 572.18 L 213.63 571 L 212.96 569.8 L 212.33 568.58 L 211.74 567.33 L 211.2 566.07 L 210.69 564.79 L 210.23 563.5 L 209.81 562.19 L 209.43 560.87 L 209.1 559.54 L 208.81 558.19 L 208.56 556.84 L 208.36 555.48 L 208.2 554.12 L 208.09 552.75 L 208.02 551.37 L 208 550 Z",
      "territoryIds": [
        "basalt-run",
        "emberfloor",
        "magma-vent",
        "smokestack"
      ],
      "color": "#B87333",
      "bonusAnchor": {
        "x": 279.24,
        "y": 603.7
      }
    },
    {
      "id": "leviathan-trench",
      "name": "Leviathan Trench",
      "bonus": 4,
      "shape": "M 478 400 L 478.02 398.63 L 478.09 397.25 L 478.2 395.88 L 478.36 394.52 L 478.56 393.16 L 478.81 391.81 L 479.1 390.46 L 479.43 389.13 L 479.81 387.81 L 480.23 386.5 L 480.69 385.21 L 481.2 383.93 L 481.74 382.67 L 482.33 381.42 L 482.96 380.2 L 483.63 379 L 484.33 377.82 L 485.08 376.67 L 485.86 375.54 L 486.51 374.66 L 486.51 374.66 L 486.68 374.43 L 487.53 373.36 L 488.42 372.31 L 489.35 371.29 L 490.3 370.3 L 491.29 369.35 L 492.31 368.42 L 493.36 367.53 L 494.43 366.68 L 495.54 365.86 L 496.67 365.08 L 497.82 364.33 L 499 363.63 L 500.2 362.96 L 501.42 362.33 L 502.67 361.74 L 503.93 361.2 L 505.21 360.69 L 506.5 360.23 L 507.81 359.81 L 509.13 359.43 L 510.46 359.1 L 511.81 358.81 L 513.16 358.56 L 514.52 358.36 L 515.88 358.2 L 516.18 358.18 L 576.51 324.66 L 576.68 324.43 L 577.53 323.36 L 578.42 322.31 L 579.35 321.29 L 580.3 320.3 L 581.29 319.35 L 582.31 318.42 L 583.36 317.53 L 584.43 316.68 L 585.54 315.86 L 586.67 315.08 L 587.82 314.33 L 589 313.63 L 590.2 312.96 L 591.42 312.33 L 592.67 311.74 L 593.93 311.2 L 595.21 310.69 L 596.5 310.23 L 597.81 309.81 L 599.13 309.43 L 600.46 309.1 L 601.81 308.81 L 603.16 308.56 L 604.52 308.36 L 605.88 308.2 L 606.18 308.18 L 607.25 308.09 L 608.63 308.02 L 610 308 L 611.37 308.02 L 612.75 308.09 L 613.82 308.18 L 614.12 308.2 L 615.48 308.36 L 616.84 308.56 L 618.19 308.81 L 619.54 309.1 L 620.87 309.43 L 622.19 309.81 L 623.5 310.23 L 624.79 310.69 L 626.07 311.2 L 627.33 311.74 L 628.58 312.33 L 629.8 312.96 L 631 313.63 L 632.18 314.33 L 633.33 315.08 L 634.46 315.86 L 635.57 316.68 L 636.64 317.53 L 637.69 318.42 L 638.71 319.35 L 639.7 320.3 L 640.65 321.29 L 641.58 322.31 L 642.47 323.36 L 643.32 324.43 L 643.49 324.66 L 703.82 358.18 L 704.12 358.2 L 705.48 358.36 L 706.84 358.56 L 708.19 358.81 L 709.54 359.1 L 710.87 359.43 L 712.19 359.81 L 713.5 360.23 L 714.79 360.69 L 716.07 361.2 L 717.33 361.74 L 718.58 362.33 L 719.8 362.96 L 721 363.63 L 722.18 364.33 L 723.33 365.08 L 724.46 365.86 L 725.57 366.68 L 726.64 367.53 L 727.69 368.42 L 728.71 369.35 L 729.7 370.3 L 730.65 371.29 L 731.58 372.31 L 732.47 373.36 L 733.32 374.43 L 733.49 374.66 L 734.14 375.54 L 734.92 376.67 L 735.67 377.82 L 736.37 379 L 737.04 380.2 L 737.67 381.42 L 738.26 382.67 L 738.8 383.93 L 739.31 385.21 L 739.77 386.5 L 740.19 387.81 L 740.57 389.13 L 740.9 390.46 L 741 390.93 L 741.19 391.81 L 741.44 393.16 L 741.64 394.52 L 741.8 395.88 L 741.91 397.25 L 741.98 398.63 L 742 400 L 741.98 401.37 L 741.91 402.75 L 741.8 404.12 L 741.64 405.48 L 741.44 406.84 L 741.19 408.19 L 741 409.07 L 741 490.93 L 741.19 491.81 L 741.44 493.16 L 741.64 494.52 L 741.8 495.88 L 741.91 497.25 L 741.98 498.63 L 742 500 L 741.98 501.37 L 741.91 502.75 L 741.8 504.12 L 741.64 505.48 L 741.44 506.84 L 741.19 508.19 L 741 509.07 L 740.9 509.54 L 740.57 510.87 L 740.19 512.19 L 739.77 513.5 L 739.31 514.79 L 738.8 516.07 L 738.26 517.33 L 737.67 518.58 L 737.04 519.8 L 736.37 521 L 735.67 522.18 L 734.92 523.33 L 734.14 524.46 L 733.32 525.57 L 732.47 526.64 L 731.58 527.69 L 730.65 528.71 L 729.7 529.7 L 728.71 530.65 L 727.69 531.58 L 726.64 532.47 L 725.57 533.32 L 724.46 534.14 L 723.33 534.92 L 722.18 535.67 L 721 536.37 L 719.8 537.04 L 629.8 587.04 L 628.58 587.67 L 627.33 588.26 L 626.07 588.8 L 624.79 589.31 L 623.5 589.77 L 622.19 590.19 L 620.87 590.57 L 619.54 590.9 L 618.19 591.19 L 616.84 591.44 L 615.48 591.64 L 614.12 591.8 L 612.75 591.91 L 611.37 591.98 L 610 592 L 608.63 591.98 L 607.25 591.91 L 605.88 591.8 L 604.52 591.64 L 603.16 591.44 L 601.81 591.19 L 600.46 590.9 L 599.13 590.57 L 597.81 590.19 L 596.5 589.77 L 595.21 589.31 L 593.93 588.8 L 592.67 588.26 L 591.42 587.67 L 590.2 587.04 L 589 586.37 L 587.82 585.67 L 586.67 584.92 L 585.54 584.14 L 584.43 583.32 L 583.36 582.47 L 582.31 581.58 L 581.29 580.65 L 580.3 579.7 L 579.35 578.71 L 578.42 577.69 L 577.53 576.64 L 576.68 575.57 L 575.86 574.46 L 575.08 573.33 L 574.33 572.18 L 573.63 571 L 572.96 569.8 L 572.33 568.58 L 571.74 567.33 L 571.2 566.07 L 570.69 564.79 L 570.23 563.5 L 569.81 562.19 L 569.43 560.87 L 569.1 559.54 L 569 559.07 L 568.81 558.19 L 568.56 556.84 L 568.36 555.48 L 568.2 554.12 L 568.09 552.75 L 568.02 551.37 L 568 550 L 568.02 548.63 L 568.09 547.25 L 568.2 545.88 L 568.36 544.52 L 568.56 543.16 L 568.81 541.81 L 569 540.93 L 569 471.17 L 516.18 441.82 L 515.88 441.8 L 514.52 441.64 L 513.16 441.44 L 511.81 441.19 L 510.46 440.9 L 509.13 440.57 L 507.81 440.19 L 506.5 439.77 L 505.21 439.31 L 503.93 438.8 L 502.67 438.26 L 501.42 437.67 L 500.2 437.04 L 499 436.37 L 497.82 435.67 L 496.67 434.92 L 495.54 434.14 L 494.43 433.32 L 493.36 432.47 L 492.31 431.58 L 491.29 430.65 L 490.3 429.7 L 489.35 428.71 L 488.42 427.69 L 487.53 426.64 L 486.68 425.57 L 486.51 425.34 L 486.51 425.34 L 485.86 424.46 L 485.08 423.33 L 484.33 422.18 L 483.63 421 L 482.96 419.8 L 482.33 418.58 L 481.74 417.33 L 481.2 416.07 L 480.69 414.79 L 480.23 413.5 L 479.81 412.19 L 479.43 410.87 L 479.1 409.54 L 478.81 408.19 L 478.56 406.84 L 478.36 405.48 L 478.2 404.12 L 478.09 402.75 L 478.02 401.37 Z",
      "territoryIds": [
        "bonefield",
        "hadal-gate",
        "krakenmaw",
        "leviathans-rest",
        "siphon-deep",
        "whalefall"
      ],
      "color": "#0B8F52",
      "bonusAnchor": {
        "x": 630.93,
        "y": 401.6
      }
    },
    {
      "id": "pearl-atolls",
      "name": "Pearl Atolls",
      "bonus": 2,
      "shape": "M 928 450 L 928.02 448.63 L 928.09 447.25 L 928.2 445.88 L 928.36 444.52 L 928.56 443.16 L 928.81 441.81 L 929.1 440.46 L 929.43 439.13 L 929.81 437.81 L 930.23 436.5 L 930.69 435.21 L 931.2 433.93 L 931.74 432.67 L 932.33 431.42 L 932.96 430.2 L 933.63 429 L 934.33 427.82 L 935.08 426.67 L 935.86 425.54 L 936.68 424.43 L 937.53 423.36 L 938.42 422.31 L 939.35 421.29 L 940.3 420.3 L 941.29 419.35 L 942.31 418.42 L 943.36 417.53 L 944.43 416.68 L 945.54 415.86 L 946.67 415.08 L 947.82 414.33 L 949 413.63 L 950.2 412.96 L 951.42 412.33 L 952.67 411.74 L 953.93 411.2 L 955.21 410.69 L 956.5 410.23 L 957.81 409.81 L 959.13 409.43 L 960.46 409.1 L 961.81 408.81 L 963.16 408.56 L 964.52 408.36 L 965.88 408.2 L 967.25 408.09 L 968.63 408.02 L 970 408 L 971.37 408.02 L 972.75 408.09 L 973.82 408.18 L 973.82 408.18 L 974.12 408.2 L 975.48 408.36 L 976.84 408.56 L 978.19 408.81 L 979.54 409.1 L 980.87 409.43 L 982.19 409.81 L 983.5 410.23 L 984.79 410.69 L 986.07 411.2 L 987.33 411.74 L 988.58 412.33 L 989.8 412.96 L 991 413.63 L 992.18 414.33 L 993.33 415.08 L 994.46 415.86 L 995.57 416.68 L 996.64 417.53 L 997.69 418.42 L 998.71 419.35 L 999.7 420.3 L 1000.65 421.29 L 1001.58 422.31 L 1002.47 423.36 L 1003.32 424.43 L 1003.49 424.66 L 1063.82 458.18 L 1064.12 458.2 L 1065.48 458.36 L 1066.84 458.56 L 1068.19 458.81 L 1069.54 459.1 L 1070.87 459.43 L 1072.19 459.81 L 1073.5 460.23 L 1074.79 460.69 L 1076.07 461.2 L 1077.33 461.74 L 1078.58 462.33 L 1079.8 462.96 L 1081 463.63 L 1082.18 464.33 L 1083.33 465.08 L 1084.46 465.86 L 1085.57 466.68 L 1086.64 467.53 L 1087.69 468.42 L 1088.71 469.35 L 1089.7 470.3 L 1090.65 471.29 L 1091.58 472.31 L 1092.47 473.36 L 1093.32 474.43 L 1093.49 474.66 L 1093.49 474.66 L 1094.14 475.54 L 1094.92 476.67 L 1095.67 477.82 L 1096.37 479 L 1097.04 480.2 L 1097.67 481.42 L 1098.26 482.67 L 1098.8 483.93 L 1099.31 485.21 L 1099.77 486.5 L 1100.19 487.81 L 1100.57 489.13 L 1100.9 490.46 L 1101.19 491.81 L 1101.44 493.16 L 1101.64 494.52 L 1101.8 495.88 L 1101.91 497.25 L 1101.98 498.63 L 1102 500 L 1102 600 L 1101.98 601.37 L 1101.91 602.75 L 1101.8 604.12 L 1101.64 605.48 L 1101.44 606.84 L 1101.19 608.19 L 1100.9 609.54 L 1100.57 610.87 L 1100.19 612.19 L 1099.77 613.5 L 1099.31 614.79 L 1098.8 616.07 L 1098.26 617.33 L 1097.67 618.58 L 1097.04 619.8 L 1096.37 621 L 1095.67 622.18 L 1094.92 623.33 L 1094.14 624.46 L 1093.32 625.57 L 1092.47 626.64 L 1091.58 627.69 L 1090.65 628.71 L 1089.7 629.7 L 1088.71 630.65 L 1087.69 631.58 L 1086.64 632.47 L 1085.57 633.32 L 1084.46 634.14 L 1083.33 634.92 L 1082.18 635.67 L 1081 636.37 L 1079.8 637.04 L 1078.58 637.67 L 1077.33 638.26 L 1076.07 638.8 L 1074.79 639.31 L 1073.5 639.77 L 1072.19 640.19 L 1070.87 640.57 L 1069.54 640.9 L 1068.19 641.19 L 1066.84 641.44 L 1065.48 641.64 L 1064.12 641.8 L 1062.75 641.91 L 1061.37 641.98 L 1060 642 L 1058.63 641.98 L 1057.25 641.91 L 1055.88 641.8 L 1054.52 641.64 L 1053.16 641.44 L 1051.81 641.19 L 1050.46 640.9 L 1049.13 640.57 L 1047.81 640.19 L 1046.5 639.77 L 1045.21 639.31 L 1043.93 638.8 L 1042.67 638.26 L 1041.42 637.67 L 1040.2 637.04 L 950.2 587.04 L 949 586.37 L 947.82 585.67 L 946.67 584.92 L 945.54 584.14 L 944.43 583.32 L 943.36 582.47 L 942.31 581.58 L 941.29 580.65 L 940.3 579.7 L 939.35 578.71 L 938.42 577.69 L 937.53 576.64 L 936.68 575.57 L 935.86 574.46 L 935.08 573.33 L 934.33 572.18 L 933.63 571 L 932.96 569.8 L 932.33 568.58 L 931.74 567.33 L 931.2 566.07 L 930.69 564.79 L 930.23 563.5 L 929.81 562.19 L 929.43 560.87 L 929.1 559.54 L 928.81 558.19 L 928.56 556.84 L 928.36 555.48 L 928.2 554.12 L 928.09 552.75 L 928.02 551.37 L 928 550 Z",
      "territoryIds": [
        "moonshell",
        "nacre-isle",
        "oyster-crown",
        "pearlbed"
      ],
      "color": "#FFD600",
      "bonusAnchor": {
        "x": 998.46,
        "y": 605.83
      }
    },
    {
      "id": "poseidon-domes",
      "name": "Poseidon Domes",
      "bonus": 2,
      "shape": "M 28 250 L 28.02 248.63 L 28.09 247.25 L 28.2 245.88 L 28.36 244.52 L 28.56 243.16 L 28.81 241.81 L 29.1 240.46 L 29.43 239.13 L 29.81 237.81 L 30.23 236.5 L 30.69 235.21 L 31.2 233.93 L 31.74 232.67 L 32.33 231.42 L 32.96 230.2 L 33.63 229 L 34.33 227.82 L 35.08 226.67 L 35.86 225.54 L 36.68 224.43 L 37.53 223.36 L 38.42 222.31 L 39.35 221.29 L 40.3 220.3 L 41.29 219.35 L 42.31 218.42 L 43.36 217.53 L 44.43 216.68 L 45.54 215.86 L 46.67 215.08 L 47.82 214.33 L 49 213.63 L 50.2 212.96 L 51.42 212.33 L 52.67 211.74 L 53.93 211.2 L 55.21 210.69 L 56.5 210.23 L 57.81 209.81 L 59.13 209.43 L 60.46 209.1 L 61.81 208.81 L 63.16 208.56 L 64.52 208.36 L 65.88 208.2 L 67.25 208.09 L 68.63 208.02 L 70 208 L 71.37 208.02 L 72.75 208.09 L 74.12 208.2 L 75.48 208.36 L 76.84 208.56 L 78.19 208.81 L 79.54 209.1 L 80.87 209.43 L 82.19 209.81 L 83.5 210.23 L 84.79 210.69 L 86.07 211.2 L 87.33 211.74 L 88.58 212.33 L 89.8 212.96 L 91 213.63 L 92.18 214.33 L 93.33 215.08 L 94.46 215.86 L 95.57 216.68 L 96.64 217.53 L 97.69 218.42 L 98.71 219.35 L 99.7 220.3 L 100.65 221.29 L 101.58 222.31 L 102.47 223.36 L 103.32 224.43 L 104.14 225.54 L 104.92 226.67 L 105.67 227.82 L 106.37 229 L 107.04 230.2 L 107.67 231.42 L 108.26 232.67 L 108.8 233.93 L 109.31 235.21 L 109.77 236.5 L 110.19 237.81 L 110.57 239.13 L 110.9 240.46 L 111 240.93 L 111.19 241.81 L 111.44 243.16 L 111.64 244.52 L 111.8 245.88 L 111.91 247.25 L 111.98 248.63 L 112 250 L 111.98 251.37 L 111.91 252.75 L 111.8 254.12 L 111.64 255.48 L 111.44 256.84 L 111.19 258.19 L 111 259.07 L 111 328.83 L 163.82 358.18 L 164.12 358.2 L 165.48 358.36 L 166.84 358.56 L 168.19 358.81 L 169.54 359.1 L 170.87 359.43 L 172.19 359.81 L 173.5 360.23 L 174.79 360.69 L 176.07 361.2 L 177.33 361.74 L 178.58 362.33 L 179.8 362.96 L 181 363.63 L 182.18 364.33 L 183.33 365.08 L 184.46 365.86 L 185.57 366.68 L 186.64 367.53 L 187.69 368.42 L 188.71 369.35 L 189.7 370.3 L 190.65 371.29 L 191.58 372.31 L 192.47 373.36 L 193.32 374.43 L 193.49 374.66 L 194.14 375.54 L 194.92 376.67 L 195.67 377.82 L 196.37 379 L 197.04 380.2 L 197.67 381.42 L 198.26 382.67 L 198.8 383.93 L 199.31 385.21 L 199.77 386.5 L 200.19 387.81 L 200.57 389.13 L 200.9 390.46 L 201.19 391.81 L 201.44 393.16 L 201.64 394.52 L 201.8 395.88 L 201.91 397.25 L 201.98 398.63 L 202 400 L 201.98 401.37 L 201.91 402.75 L 201.8 404.12 L 201.64 405.48 L 201.44 406.84 L 201.19 408.19 L 200.9 409.54 L 200.57 410.87 L 200.19 412.19 L 199.77 413.5 L 199.31 414.79 L 198.8 416.07 L 198.26 417.33 L 197.67 418.58 L 197.04 419.8 L 196.37 421 L 195.67 422.18 L 194.92 423.33 L 194.14 424.46 L 193.32 425.57 L 192.47 426.64 L 191.58 427.69 L 190.65 428.71 L 189.7 429.7 L 188.71 430.65 L 187.69 431.58 L 186.64 432.47 L 185.57 433.32 L 184.46 434.14 L 183.33 434.92 L 182.18 435.67 L 181 436.37 L 179.8 437.04 L 178.58 437.67 L 177.33 438.26 L 176.07 438.8 L 174.79 439.31 L 173.5 439.77 L 172.19 440.19 L 170.87 440.57 L 169.54 440.9 L 168.19 441.19 L 166.84 441.44 L 165.48 441.64 L 164.12 441.8 L 162.75 441.91 L 161.37 441.98 L 160 442 L 158.63 441.98 L 157.25 441.91 L 155.88 441.8 L 154.52 441.64 L 153.16 441.44 L 151.81 441.19 L 150.46 440.9 L 149.13 440.57 L 147.81 440.19 L 146.5 439.77 L 145.21 439.31 L 143.93 438.8 L 142.67 438.26 L 141.42 437.67 L 140.2 437.04 L 50.2 387.04 L 49 386.37 L 47.82 385.67 L 46.67 384.92 L 45.54 384.14 L 44.43 383.32 L 43.36 382.47 L 42.31 381.58 L 41.29 380.65 L 40.3 379.7 L 39.35 378.71 L 38.42 377.69 L 37.53 376.64 L 36.68 375.57 L 35.86 374.46 L 35.08 373.33 L 34.33 372.18 L 33.63 371 L 32.96 369.8 L 32.33 368.58 L 31.74 367.33 L 31.2 366.07 L 30.69 364.79 L 30.23 363.5 L 29.81 362.19 L 29.43 360.87 L 29.1 359.54 L 28.81 358.19 L 28.56 356.84 L 28.36 355.48 L 28.2 354.12 L 28.09 352.75 L 28.02 351.37 L 28 350 Z",
      "territoryIds": [
        "aquadome",
        "bathysphere",
        "seastead"
      ],
      "color": "#E040FB",
      "bonusAnchor": {
        "x": 97.19,
        "y": 408.75
      }
    },
    {
      "id": "tidewatch-stations",
      "name": "Tidewatch Stations",
      "bonus": 2,
      "shape": "M 298 400 L 298.02 398.63 L 298.09 397.25 L 298.2 395.88 L 298.36 394.52 L 298.56 393.16 L 298.81 391.81 L 299.1 390.46 L 299.43 389.13 L 299.81 387.81 L 300.23 386.5 L 300.69 385.21 L 301.2 383.93 L 301.74 382.67 L 302.33 381.42 L 302.96 380.2 L 303.63 379 L 304.33 377.82 L 305.08 376.67 L 305.86 375.54 L 306.51 374.66 L 306.51 374.66 L 306.68 374.43 L 307.53 373.36 L 308.42 372.31 L 309.35 371.29 L 310.3 370.3 L 311.29 369.35 L 312.31 368.42 L 313.36 367.53 L 314.43 366.68 L 315.54 365.86 L 316.67 365.08 L 317.82 364.33 L 319 363.63 L 320.2 362.96 L 321.42 362.33 L 322.67 361.74 L 323.93 361.2 L 325.21 360.69 L 326.5 360.23 L 327.81 359.81 L 329.13 359.43 L 330.46 359.1 L 331.81 358.81 L 333.16 358.56 L 334.52 358.36 L 335.88 358.2 L 336.18 358.18 L 389 328.83 L 389 259.07 L 388.81 258.19 L 388.56 256.84 L 388.36 255.48 L 388.2 254.12 L 388.09 252.75 L 388.02 251.37 L 388 250 L 388.02 248.63 L 388.09 247.25 L 388.2 245.88 L 388.36 244.52 L 388.56 243.16 L 388.81 241.81 L 389 240.93 L 389.1 240.46 L 389.43 239.13 L 389.81 237.81 L 390.23 236.5 L 390.69 235.21 L 391.2 233.93 L 391.74 232.67 L 392.33 231.42 L 392.96 230.2 L 393.63 229 L 394.33 227.82 L 395.08 226.67 L 395.86 225.54 L 396.68 224.43 L 397.53 223.36 L 398.42 222.31 L 399.35 221.29 L 400.3 220.3 L 401.29 219.35 L 402.31 218.42 L 403.36 217.53 L 404.43 216.68 L 405.54 215.86 L 406.67 215.08 L 407.82 214.33 L 409 213.63 L 410.2 212.96 L 411.42 212.33 L 412.67 211.74 L 413.93 211.2 L 415.21 210.69 L 416.5 210.23 L 417.81 209.81 L 419.13 209.43 L 420.46 209.1 L 421.81 208.81 L 423.16 208.56 L 424.52 208.36 L 425.88 208.2 L 427.25 208.09 L 428.63 208.02 L 430 208 L 431.37 208.02 L 432.75 208.09 L 434.12 208.2 L 435.48 208.36 L 436.84 208.56 L 438.19 208.81 L 439.54 209.1 L 440.87 209.43 L 442.19 209.81 L 443.5 210.23 L 444.79 210.69 L 446.07 211.2 L 447.33 211.74 L 448.58 212.33 L 449.8 212.96 L 451 213.63 L 452.18 214.33 L 453.33 215.08 L 454.46 215.86 L 455.57 216.68 L 456.64 217.53 L 457.69 218.42 L 458.71 219.35 L 459.7 220.3 L 460.65 221.29 L 461.58 222.31 L 462.47 223.36 L 463.32 224.43 L 464.14 225.54 L 464.92 226.67 L 465.67 227.82 L 466.37 229 L 467.04 230.2 L 467.67 231.42 L 468.26 232.67 L 468.8 233.93 L 469.31 235.21 L 469.77 236.5 L 470.19 237.81 L 470.57 239.13 L 470.9 240.46 L 471 240.93 L 471.19 241.81 L 471.44 243.16 L 471.64 244.52 L 471.8 245.88 L 471.91 247.25 L 471.98 248.63 L 472 250 L 471.98 251.37 L 471.91 252.75 L 471.8 254.12 L 471.64 255.48 L 471.44 256.84 L 471.19 258.19 L 471 259.07 L 471 340.93 L 471.19 341.81 L 471.44 343.16 L 471.64 344.52 L 471.8 345.88 L 471.91 347.25 L 471.98 348.63 L 472 350 L 471.98 351.37 L 471.91 352.75 L 471.8 354.12 L 471.64 355.48 L 471.44 356.84 L 471.19 358.19 L 471 359.07 L 470.9 359.54 L 470.57 360.87 L 470.19 362.19 L 469.77 363.5 L 469.31 364.79 L 468.8 366.07 L 468.26 367.33 L 467.67 368.58 L 467.04 369.8 L 466.37 371 L 465.67 372.18 L 464.92 373.33 L 464.14 374.46 L 463.32 375.57 L 462.47 376.64 L 461.58 377.69 L 460.65 378.71 L 459.7 379.7 L 458.71 380.65 L 457.69 381.58 L 456.64 382.47 L 455.57 383.32 L 454.46 384.14 L 453.33 384.92 L 452.18 385.67 L 451 386.37 L 449.8 387.04 L 359.8 437.04 L 358.58 437.67 L 357.33 438.26 L 356.07 438.8 L 354.79 439.31 L 353.5 439.77 L 352.19 440.19 L 350.87 440.57 L 349.54 440.9 L 348.19 441.19 L 346.84 441.44 L 345.48 441.64 L 344.12 441.8 L 342.75 441.91 L 341.37 441.98 L 340 442 L 338.63 441.98 L 337.25 441.91 L 335.88 441.8 L 334.52 441.64 L 333.16 441.44 L 331.81 441.19 L 330.46 440.9 L 329.13 440.57 L 327.81 440.19 L 326.5 439.77 L 325.21 439.31 L 323.93 438.8 L 322.67 438.26 L 321.42 437.67 L 320.2 437.04 L 319 436.37 L 317.82 435.67 L 316.67 434.92 L 315.54 434.14 L 314.43 433.32 L 313.36 432.47 L 312.31 431.58 L 311.29 430.65 L 310.3 429.7 L 309.35 428.71 L 308.42 427.69 L 307.53 426.64 L 306.68 425.57 L 305.86 424.46 L 305.08 423.33 L 304.33 422.18 L 303.63 421 L 302.96 419.8 L 302.33 418.58 L 301.74 417.33 L 301.2 416.07 L 300.69 414.79 L 300.23 413.5 L 299.81 412.19 L 299.43 410.87 L 299.1 409.54 L 298.81 408.19 L 298.56 406.84 L 298.36 405.48 L 298.2 404.12 L 298.09 402.75 L 298.02 401.37 Z",
      "territoryIds": [
        "beacon-deep",
        "buoyhold",
        "tidewatch"
      ],
      "color": "#D7263D",
      "bonusAnchor": {
        "x": 401.22,
        "y": 406.71
      }
    },
    {
      "id": "kelp-farms",
      "name": "Kelp Farms",
      "bonus": 1,
      "shape": "M 388 550 L 388.02 548.63 L 388.09 547.25 L 388.2 545.88 L 388.36 544.52 L 388.56 543.16 L 388.81 541.81 L 389.1 540.46 L 389.43 539.13 L 389.81 537.81 L 390.23 536.5 L 390.69 535.21 L 391.2 533.93 L 391.74 532.67 L 392.33 531.42 L 392.96 530.2 L 393.63 529 L 394.33 527.82 L 395.08 526.67 L 395.86 525.54 L 396.68 524.43 L 397.53 523.36 L 398.42 522.31 L 399.35 521.29 L 400.3 520.3 L 401.29 519.35 L 402.31 518.42 L 403.36 517.53 L 404.43 516.68 L 405.54 515.86 L 406.67 515.08 L 407.82 514.33 L 409 513.63 L 410.2 512.96 L 500.2 462.96 L 501.42 462.33 L 502.67 461.74 L 503.93 461.2 L 505.21 460.69 L 506.5 460.23 L 507.81 459.81 L 509.13 459.43 L 510.46 459.1 L 511.81 458.81 L 513.16 458.56 L 514.52 458.36 L 515.88 458.2 L 517.25 458.09 L 518.63 458.02 L 520 458 L 521.37 458.02 L 522.75 458.09 L 524.12 458.2 L 525.48 458.36 L 526.84 458.56 L 528.19 458.81 L 529.54 459.1 L 530.87 459.43 L 532.19 459.81 L 533.5 460.23 L 534.79 460.69 L 536.07 461.2 L 537.33 461.74 L 538.58 462.33 L 539.8 462.96 L 541 463.63 L 542.18 464.33 L 543.33 465.08 L 544.46 465.86 L 545.57 466.68 L 546.64 467.53 L 547.69 468.42 L 548.71 469.35 L 549.7 470.3 L 550.65 471.29 L 551.58 472.31 L 552.47 473.36 L 553.32 474.43 L 554.14 475.54 L 554.92 476.67 L 555.67 477.82 L 556.37 479 L 557.04 480.2 L 557.67 481.42 L 558.26 482.67 L 558.8 483.93 L 559.31 485.21 L 559.77 486.5 L 560.19 487.81 L 560.57 489.13 L 560.9 490.46 L 561.19 491.81 L 561.44 493.16 L 561.64 494.52 L 561.8 495.88 L 561.91 497.25 L 561.98 498.63 L 562 500 L 561.98 501.37 L 561.91 502.75 L 561.8 504.12 L 561.64 505.48 L 561.44 506.84 L 561.19 508.19 L 560.9 509.54 L 560.57 510.87 L 560.19 512.19 L 559.77 513.5 L 559.31 514.79 L 558.8 516.07 L 558.26 517.33 L 557.67 518.58 L 557.04 519.8 L 556.37 521 L 555.67 522.18 L 554.92 523.33 L 554.14 524.46 L 553.32 525.57 L 552.47 526.64 L 551.58 527.69 L 550.65 528.71 L 549.7 529.7 L 548.71 530.65 L 547.69 531.58 L 546.64 532.47 L 545.57 533.32 L 544.46 534.14 L 543.33 534.92 L 542.18 535.67 L 541 536.37 L 539.8 537.04 L 449.8 587.04 L 448.58 587.67 L 447.33 588.26 L 446.07 588.8 L 444.79 589.31 L 443.5 589.77 L 442.19 590.19 L 440.87 590.57 L 439.54 590.9 L 438.19 591.19 L 436.84 591.44 L 435.48 591.64 L 434.12 591.8 L 432.75 591.91 L 431.37 591.98 L 430 592 L 428.63 591.98 L 427.25 591.91 L 425.88 591.8 L 424.52 591.64 L 423.16 591.44 L 421.81 591.19 L 420.46 590.9 L 419.13 590.57 L 417.81 590.19 L 416.5 589.77 L 415.21 589.31 L 413.93 588.8 L 412.67 588.26 L 411.42 587.67 L 410.2 587.04 L 409 586.37 L 407.82 585.67 L 406.67 584.92 L 405.54 584.14 L 404.43 583.32 L 403.36 582.47 L 402.31 581.58 L 401.29 580.65 L 400.3 579.7 L 399.35 578.71 L 398.42 577.69 L 397.53 576.64 L 396.68 575.57 L 395.86 574.46 L 395.08 573.33 L 394.33 572.18 L 393.63 571 L 392.96 569.8 L 392.33 568.58 L 391.74 567.33 L 391.2 566.07 L 390.69 564.79 L 390.23 563.5 L 389.81 562.19 L 389.43 560.87 L 389.1 559.54 L 388.81 558.19 L 388.56 556.84 L 388.36 555.48 L 388.2 554.12 L 388.09 552.75 L 388.02 551.37 Z",
      "territoryIds": [
        "algae-works",
        "greenhouse-dome"
      ],
      "color": "#C6F432",
      "bonusAnchor": {
        "x": 458.94,
        "y": 489.15
      }
    },
    {
      "id": "thermal-habitats",
      "name": "Thermal Habitats",
      "bonus": 2,
      "shape": "M 748 450 L 748.02 448.63 L 748.09 447.25 L 748.2 445.88 L 748.36 444.52 L 748.56 443.16 L 748.81 441.81 L 749 440.93 L 749.1 440.46 L 749.43 439.13 L 749.81 437.81 L 750.23 436.5 L 750.69 435.21 L 751.2 433.93 L 751.74 432.67 L 752.33 431.42 L 752.96 430.2 L 753.63 429 L 754.33 427.82 L 755.08 426.67 L 755.86 425.54 L 756.68 424.43 L 757.53 423.36 L 758.42 422.31 L 759.35 421.29 L 760.3 420.3 L 761.29 419.35 L 762.31 418.42 L 763.36 417.53 L 764.43 416.68 L 765.54 415.86 L 766.67 415.08 L 767.82 414.33 L 769 413.63 L 770.2 412.96 L 771.42 412.33 L 772.67 411.74 L 773.93 411.2 L 775.21 410.69 L 776.5 410.23 L 777.81 409.81 L 779.13 409.43 L 780.46 409.1 L 781.81 408.81 L 783.16 408.56 L 784.52 408.36 L 785.88 408.2 L 787.25 408.09 L 788.63 408.02 L 790 408 L 791.37 408.02 L 792.75 408.09 L 794.12 408.2 L 795.48 408.36 L 796.84 408.56 L 798.19 408.81 L 799.54 409.1 L 800.87 409.43 L 802.19 409.81 L 803.5 410.23 L 804.79 410.69 L 806.07 411.2 L 807.33 411.74 L 808.58 412.33 L 809.8 412.96 L 811 413.63 L 812.18 414.33 L 813.33 415.08 L 814.46 415.86 L 815.57 416.68 L 816.64 417.53 L 817.69 418.42 L 818.71 419.35 L 819.7 420.3 L 820.65 421.29 L 821.58 422.31 L 822.47 423.36 L 823.32 424.43 L 824.14 425.54 L 824.92 426.67 L 825.67 427.82 L 826.37 429 L 827.04 430.2 L 827.67 431.42 L 828.26 432.67 L 828.8 433.93 L 829.31 435.21 L 829.77 436.5 L 830.19 437.81 L 830.57 439.13 L 830.9 440.46 L 831.19 441.81 L 831.44 443.16 L 831.64 444.52 L 831.8 445.88 L 831.91 447.25 L 831.98 448.63 L 832 450 L 832 525.29 L 899.8 562.96 L 901 563.63 L 902.18 564.33 L 903.33 565.08 L 904.46 565.86 L 905.57 566.68 L 906.64 567.53 L 907.69 568.42 L 908.71 569.35 L 909.7 570.3 L 910.65 571.29 L 911.58 572.31 L 912.47 573.36 L 913.32 574.43 L 914.14 575.54 L 914.92 576.67 L 915.67 577.82 L 916.37 579 L 917.04 580.2 L 917.67 581.42 L 918.26 582.67 L 918.8 583.93 L 919.31 585.21 L 919.77 586.5 L 920.19 587.81 L 920.57 589.13 L 920.9 590.46 L 921.19 591.81 L 921.44 593.16 L 921.64 594.52 L 921.8 595.88 L 921.91 597.25 L 921.98 598.63 L 922 600 L 921.98 601.37 L 921.91 602.75 L 921.8 604.12 L 921.64 605.48 L 921.44 606.84 L 921.19 608.19 L 920.9 609.54 L 920.57 610.87 L 920.19 612.19 L 919.77 613.5 L 919.31 614.79 L 918.8 616.07 L 918.26 617.33 L 917.67 618.58 L 917.04 619.8 L 916.37 621 L 915.67 622.18 L 914.92 623.33 L 914.14 624.46 L 913.32 625.57 L 912.47 626.64 L 911.58 627.69 L 910.65 628.71 L 909.7 629.7 L 908.71 630.65 L 907.69 631.58 L 906.64 632.47 L 905.57 633.32 L 904.46 634.14 L 903.33 634.92 L 902.18 635.67 L 901 636.37 L 899.8 637.04 L 898.58 637.67 L 897.33 638.26 L 896.07 638.8 L 894.79 639.31 L 893.5 639.77 L 892.19 640.19 L 890.87 640.57 L 889.54 640.9 L 888.19 641.19 L 886.84 641.44 L 885.48 641.64 L 884.12 641.8 L 882.75 641.91 L 881.37 641.98 L 880 642 L 878.63 641.98 L 877.25 641.91 L 875.88 641.8 L 874.52 641.64 L 873.16 641.44 L 871.81 641.19 L 870.46 640.9 L 869.13 640.57 L 867.81 640.19 L 866.5 639.77 L 865.21 639.31 L 863.93 638.8 L 862.67 638.26 L 861.42 637.67 L 860.2 637.04 L 770.2 587.04 L 769 586.37 L 767.82 585.67 L 766.67 584.92 L 765.54 584.14 L 764.43 583.32 L 763.36 582.47 L 762.31 581.58 L 761.29 580.65 L 760.3 579.7 L 759.35 578.71 L 758.42 577.69 L 757.53 576.64 L 756.68 575.57 L 755.86 574.46 L 755.08 573.33 L 754.33 572.18 L 753.63 571 L 752.96 569.8 L 752.33 568.58 L 751.74 567.33 L 751.2 566.07 L 750.69 564.79 L 750.23 563.5 L 749.81 562.19 L 749.43 560.87 L 749.1 559.54 L 749 559.07 L 748.81 558.19 L 748.56 556.84 L 748.36 555.48 L 748.2 554.12 L 748.09 552.75 L 748.02 551.37 L 748 550 L 748.02 548.63 L 748.09 547.25 L 748.2 545.88 L 748.36 544.52 L 748.56 543.16 L 748.81 541.81 L 749 540.93 L 749 459.07 L 748.81 458.19 L 748.56 456.84 L 748.36 455.48 L 748.2 454.12 L 748.09 452.75 L 748.02 451.37 Z",
      "territoryIds": [
        "geotherm",
        "hotspring",
        "ventside"
      ],
      "color": "#9C27B0",
      "bonusAnchor": {
        "x": 836.23,
        "y": 527.85
      }
    },
    {
      "id": "sonar-outposts",
      "name": "Sonar Outposts",
      "bonus": 1,
      "shape": "M 928 350 L 928.02 348.63 L 928.09 347.25 L 928.2 345.88 L 928.36 344.52 L 928.56 343.16 L 928.81 341.81 L 929.1 340.46 L 929.43 339.13 L 929.81 337.81 L 930.23 336.5 L 930.69 335.21 L 931.2 333.93 L 931.74 332.67 L 932.33 331.42 L 932.96 330.2 L 933.63 329 L 934.33 327.82 L 935.08 326.67 L 935.86 325.54 L 936.68 324.43 L 937.53 323.36 L 938.42 322.31 L 939.35 321.29 L 940.3 320.3 L 941.29 319.35 L 942.31 318.42 L 943.36 317.53 L 944.43 316.68 L 945.54 315.86 L 946.67 315.08 L 947.82 314.33 L 949 313.63 L 950.2 312.96 L 951.42 312.33 L 952.67 311.74 L 953.93 311.2 L 955.21 310.69 L 956.5 310.23 L 957.81 309.81 L 959.13 309.43 L 960.46 309.1 L 961.81 308.81 L 963.16 308.56 L 964.52 308.36 L 965.88 308.2 L 967.25 308.09 L 968.63 308.02 L 970 308 L 971.37 308.02 L 972.75 308.09 L 973.82 308.18 L 974.12 308.2 L 975.48 308.36 L 976.84 308.56 L 978.19 308.81 L 979.54 309.1 L 980.87 309.43 L 982.19 309.81 L 983.5 310.23 L 984.79 310.69 L 986.07 311.2 L 987.33 311.74 L 988.58 312.33 L 989.8 312.96 L 991 313.63 L 992.18 314.33 L 993.33 315.08 L 994.46 315.86 L 995.57 316.68 L 996.64 317.53 L 997.69 318.42 L 998.71 319.35 L 999.7 320.3 L 1000.65 321.29 L 1001.58 322.31 L 1002.47 323.36 L 1003.32 324.43 L 1003.49 324.66 L 1063.82 358.18 L 1064.12 358.2 L 1065.48 358.36 L 1066.84 358.56 L 1068.19 358.81 L 1069.54 359.1 L 1070.87 359.43 L 1072.19 359.81 L 1073.5 360.23 L 1074.79 360.69 L 1076.07 361.2 L 1077.33 361.74 L 1078.58 362.33 L 1079.8 362.96 L 1081 363.63 L 1082.18 364.33 L 1083.33 365.08 L 1084.46 365.86 L 1085.57 366.68 L 1086.64 367.53 L 1087.69 368.42 L 1088.71 369.35 L 1089.7 370.3 L 1090.65 371.29 L 1091.58 372.31 L 1092.47 373.36 L 1093.32 374.43 L 1093.49 374.66 L 1094.14 375.54 L 1094.92 376.67 L 1095.67 377.82 L 1096.37 379 L 1097.04 380.2 L 1097.67 381.42 L 1098.26 382.67 L 1098.8 383.93 L 1099.31 385.21 L 1099.77 386.5 L 1100.19 387.81 L 1100.57 389.13 L 1100.9 390.46 L 1101.19 391.81 L 1101.44 393.16 L 1101.64 394.52 L 1101.8 395.88 L 1101.91 397.25 L 1101.98 398.63 L 1102 400 L 1101.98 401.37 L 1101.91 402.75 L 1101.8 404.12 L 1101.64 405.48 L 1101.44 406.84 L 1101.19 408.19 L 1100.9 409.54 L 1100.57 410.87 L 1100.19 412.19 L 1099.77 413.5 L 1099.31 414.79 L 1098.8 416.07 L 1098.26 417.33 L 1097.67 418.58 L 1097.04 419.8 L 1096.37 421 L 1095.67 422.18 L 1094.92 423.33 L 1094.14 424.46 L 1093.32 425.57 L 1092.47 426.64 L 1091.58 427.69 L 1090.65 428.71 L 1089.7 429.7 L 1088.71 430.65 L 1087.69 431.58 L 1086.64 432.47 L 1085.57 433.32 L 1084.46 434.14 L 1083.33 434.92 L 1082.18 435.67 L 1081 436.37 L 1079.8 437.04 L 1078.58 437.67 L 1077.33 438.26 L 1076.07 438.8 L 1074.79 439.31 L 1073.5 439.77 L 1072.19 440.19 L 1070.87 440.57 L 1069.54 440.9 L 1068.19 441.19 L 1066.84 441.44 L 1065.48 441.64 L 1064.12 441.8 L 1062.75 441.91 L 1061.37 441.98 L 1060 442 L 1058.63 441.98 L 1057.25 441.91 L 1056.18 441.82 L 1055.88 441.8 L 1054.52 441.64 L 1053.16 441.44 L 1051.81 441.19 L 1050.46 440.9 L 1049.13 440.57 L 1047.81 440.19 L 1046.5 439.77 L 1045.21 439.31 L 1043.93 438.8 L 1042.67 438.26 L 1041.42 437.67 L 1040.2 437.04 L 1039 436.37 L 1037.82 435.67 L 1036.67 434.92 L 1035.54 434.14 L 1034.43 433.32 L 1033.36 432.47 L 1032.31 431.58 L 1031.29 430.65 L 1030.3 429.7 L 1029.35 428.71 L 1028.42 427.69 L 1027.53 426.64 L 1026.68 425.57 L 1026.51 425.34 L 966.18 391.82 L 965.88 391.8 L 964.52 391.64 L 963.16 391.44 L 961.81 391.19 L 960.46 390.9 L 959.13 390.57 L 957.81 390.19 L 956.5 389.77 L 955.21 389.31 L 953.93 388.8 L 952.67 388.26 L 951.42 387.67 L 950.2 387.04 L 949 386.37 L 947.82 385.67 L 946.67 384.92 L 945.54 384.14 L 944.43 383.32 L 943.36 382.47 L 942.31 381.58 L 941.29 380.65 L 940.3 379.7 L 939.35 378.71 L 938.42 377.69 L 937.53 376.64 L 936.68 375.57 L 936.51 375.34 L 936.51 375.34 L 935.86 374.46 L 935.08 373.33 L 934.33 372.18 L 933.63 371 L 932.96 369.8 L 932.33 368.58 L 931.74 367.33 L 931.2 366.07 L 930.69 364.79 L 930.23 363.5 L 929.81 362.19 L 929.43 360.87 L 929.1 359.54 L 928.81 358.19 L 928.56 356.84 L 928.36 355.48 L 928.2 354.12 L 928.09 352.75 L 928.02 351.37 Z",
      "territoryIds": [
        "periscope-post",
        "sonar-spire"
      ],
      "color": "#00796B",
      "bonusAnchor": {
        "x": 1104.31,
        "y": 391.36
      }
    },
    {
      "id": "iron-deeps",
      "name": "Iron Deeps",
      "bonus": 3,
      "shape": "M 298 710 L 298.02 708.63 L 298.09 707.25 L 298.2 705.88 L 298.36 704.52 L 298.56 703.16 L 298.81 701.81 L 299.1 700.46 L 299.43 699.13 L 299.81 697.81 L 300.23 696.5 L 300.69 695.21 L 301.2 693.93 L 301.74 692.67 L 302.33 691.42 L 302.96 690.2 L 303.63 689 L 304.33 687.82 L 305.08 686.67 L 305.86 685.54 L 306.68 684.43 L 307.53 683.36 L 308.42 682.31 L 309.35 681.29 L 310.3 680.3 L 311.29 679.35 L 312.31 678.42 L 313.36 677.53 L 314.43 676.68 L 315.54 675.86 L 316.67 675.08 L 317.82 674.33 L 319 673.63 L 320.2 672.96 L 321.42 672.33 L 322.67 671.74 L 323.93 671.2 L 325.21 670.69 L 326.5 670.23 L 327.81 669.81 L 329.13 669.43 L 330.46 669.1 L 331.81 668.81 L 333.16 668.56 L 334.52 668.36 L 335.88 668.2 L 337.25 668.09 L 338.63 668.02 L 340 668 L 880 668 L 881.37 668.02 L 882.75 668.09 L 884.12 668.2 L 885.48 668.36 L 886.84 668.56 L 888.19 668.81 L 889.54 669.1 L 890.87 669.43 L 892.19 669.81 L 893.5 670.23 L 894.79 670.69 L 896.07 671.2 L 897.33 671.74 L 898.58 672.33 L 899.8 672.96 L 901 673.63 L 902.18 674.33 L 903.33 675.08 L 904.46 675.86 L 905.57 676.68 L 906.64 677.53 L 907.69 678.42 L 908.71 679.35 L 909.7 680.3 L 910.65 681.29 L 911.58 682.31 L 912.47 683.36 L 913.32 684.43 L 914.14 685.54 L 914.92 686.67 L 915.67 687.82 L 916.37 689 L 917.04 690.2 L 917.67 691.42 L 918.26 692.67 L 918.8 693.93 L 919.31 695.21 L 919.77 696.5 L 920.19 697.81 L 920.57 699.13 L 920.9 700.46 L 921.19 701.81 L 921.44 703.16 L 921.64 704.52 L 921.8 705.88 L 921.91 707.25 L 921.98 708.63 L 922 710 L 921.98 711.37 L 921.91 712.75 L 921.8 714.12 L 921.64 715.48 L 921.44 716.84 L 921.19 718.19 L 920.9 719.54 L 920.57 720.87 L 920.19 722.19 L 919.77 723.5 L 919.31 724.79 L 918.8 726.07 L 918.26 727.33 L 917.67 728.58 L 917.04 729.8 L 916.37 731 L 915.67 732.18 L 914.92 733.33 L 914.14 734.46 L 913.32 735.57 L 912.47 736.64 L 911.58 737.69 L 910.65 738.71 L 909.7 739.7 L 908.71 740.65 L 907.69 741.58 L 906.64 742.47 L 905.57 743.32 L 904.46 744.14 L 903.33 744.92 L 902.18 745.67 L 901 746.37 L 899.8 747.04 L 898.58 747.67 L 897.33 748.26 L 896.07 748.8 L 894.79 749.31 L 893.5 749.77 L 892.19 750.19 L 890.87 750.57 L 889.54 750.9 L 888.19 751.19 L 886.84 751.44 L 885.48 751.64 L 884.12 751.8 L 882.75 751.91 L 881.37 751.98 L 880 752 L 340 752 L 338.63 751.98 L 337.25 751.91 L 335.88 751.8 L 334.52 751.64 L 333.16 751.44 L 331.81 751.19 L 330.46 750.9 L 329.13 750.57 L 327.81 750.19 L 326.5 749.77 L 325.21 749.31 L 323.93 748.8 L 322.67 748.26 L 321.42 747.67 L 320.2 747.04 L 319 746.37 L 317.82 745.67 L 316.67 744.92 L 315.54 744.14 L 314.43 743.32 L 313.36 742.47 L 312.31 741.58 L 311.29 740.65 L 310.3 739.7 L 309.35 738.71 L 308.42 737.69 L 307.53 736.64 L 306.68 735.57 L 305.86 734.46 L 305.08 733.33 L 304.33 732.18 L 303.63 731 L 302.96 729.8 L 302.33 728.58 L 301.74 727.33 L 301.2 726.07 L 300.69 724.79 L 300.23 723.5 L 299.81 722.19 L 299.43 720.87 L 299.1 719.54 L 298.81 718.19 L 298.56 716.84 L 298.36 715.48 L 298.2 714.12 L 298.09 712.75 L 298.02 711.37 Z",
      "territoryIds": [
        "anchor-yard",
        "argo-wreck",
        "ballast-hold",
        "hullbreaker",
        "keel-trench"
      ],
      "color": "#5B6B7A",
      "bonusAnchor": {
        "x": 545.45,
        "y": 673.38
      }
    }
  ],
  "territories": [
    {
      "id": "anchor-yard",
      "name": "Anchor Yard",
      "regionId": "iron-deeps",
      "adjacencies": [
        "keel-trench",
        "smokestack"
      ],
      "shape": "M 371 710 L 369.9 718 L 366.8 725.5 L 361.9 731.9 L 355.5 736.8 L 348 739.9 L 340 741 L 332 739.9 L 324.5 736.8 L 318.1 731.9 L 313.2 725.5 L 310.1 718 L 309 710 L 310.1 702 L 313.2 694.5 L 318.1 688.1 L 324.5 683.2 L 332 680.1 L 340 679 L 348 680.1 L 355.5 683.2 L 361.9 688.1 L 366.8 694.5 L 369.9 702 Z",
      "position": {
        "x": 340,
        "y": 710
      },
      "badgeAnchor": {
        "x": 340,
        "y": 710
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ballast-hold",
      "name": "Ballast Hold",
      "regionId": "iron-deeps",
      "adjacencies": [
        "argo-wreck",
        "hullbreaker"
      ],
      "shape": "M 776 710 L 774.9 718 L 771.8 725.5 L 766.9 731.9 L 760.5 736.8 L 753 739.9 L 745 741 L 737 739.9 L 729.5 736.8 L 723.1 731.9 L 718.2 725.5 L 715.1 718 L 714 710 L 715.1 702 L 718.2 694.5 L 723.1 688.1 L 729.5 683.2 L 737 680.1 L 745 679 L 753 680.1 L 760.5 683.2 L 766.9 688.1 L 771.8 694.5 L 774.9 702 Z",
      "position": {
        "x": 745,
        "y": 710
      },
      "badgeAnchor": {
        "x": 745,
        "y": 710
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "argo-wreck",
      "name": "Argo Wreck",
      "regionId": "iron-deeps",
      "adjacencies": [
        "ballast-hold",
        "keel-trench",
        "siphon-deep"
      ],
      "shape": "M 641 710 L 639.9 718 L 636.8 725.5 L 631.9 731.9 L 625.5 736.8 L 618 739.9 L 610 741 L 602 739.9 L 594.5 736.8 L 588.1 731.9 L 583.2 725.5 L 580.1 718 L 579 710 L 580.1 702 L 583.2 694.5 L 588.1 688.1 L 594.5 683.2 L 602 680.1 L 610 679 L 618 680.1 L 625.5 683.2 L 631.9 688.1 L 636.8 694.5 L 639.9 702 Z",
      "position": {
        "x": 610,
        "y": 710
      },
      "badgeAnchor": {
        "x": 610,
        "y": 710
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "smokestack",
      "name": "Smokestack",
      "regionId": "ember-rift",
      "adjacencies": [
        "anchor-yard",
        "basalt-run",
        "magma-vent"
      ],
      "shape": "M 371 600 L 369.9 608 L 366.8 615.5 L 361.9 621.9 L 355.5 626.8 L 348 629.9 L 340 631 L 332 629.9 L 324.5 626.8 L 318.1 621.9 L 313.2 615.5 L 310.1 608 L 309 600 L 310.1 592 L 313.2 584.5 L 318.1 578.1 L 324.5 573.2 L 332 570.1 L 340 569 L 348 570.1 L 355.5 573.2 L 361.9 578.1 L 366.8 584.5 L 369.9 592 Z",
      "position": {
        "x": 340,
        "y": 600
      },
      "badgeAnchor": {
        "x": 340,
        "y": 600
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "basalt-run",
      "name": "Basalt Run",
      "regionId": "ember-rift",
      "adjacencies": [
        "emberfloor",
        "magma-vent",
        "smokestack"
      ],
      "shape": "M 281 550 L 279.9 558 L 276.8 565.5 L 271.9 571.9 L 265.5 576.8 L 258 579.9 L 250 581 L 242 579.9 L 234.5 576.8 L 228.1 571.9 L 223.2 565.5 L 220.1 558 L 219 550 L 220.1 542 L 223.2 534.5 L 228.1 528.1 L 234.5 523.2 L 242 520.1 L 250 519 L 258 520.1 L 265.5 523.2 L 271.9 528.1 L 276.8 534.5 L 279.9 542 Z",
      "position": {
        "x": 250,
        "y": 550
      },
      "badgeAnchor": {
        "x": 250,
        "y": 550
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "magma-vent",
      "name": "Magma Vent",
      "regionId": "ember-rift",
      "adjacencies": [
        "algae-works",
        "basalt-run",
        "beacon-deep",
        "emberfloor",
        "smokestack",
        "whalefall"
      ],
      "shape": "M 371 500 L 369.9 508 L 366.8 515.5 L 361.9 521.9 L 355.5 526.8 L 348 529.9 L 340 531 L 332 529.9 L 324.5 526.8 L 318.1 521.9 L 313.2 515.5 L 310.1 508 L 309 500 L 310.1 492 L 313.2 484.5 L 318.1 478.1 L 324.5 473.2 L 332 470.1 L 340 469 L 348 470.1 L 355.5 473.2 L 361.9 478.1 L 366.8 484.5 L 369.9 492 Z",
      "position": {
        "x": 340,
        "y": 500
      },
      "badgeAnchor": {
        "x": 340,
        "y": 500
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "emberfloor",
      "name": "Emberfloor",
      "regionId": "ember-rift",
      "adjacencies": [
        "basalt-run",
        "magma-vent",
        "sandbar-hold",
        "seastead"
      ],
      "shape": "M 281 450 L 279.9 458 L 276.8 465.5 L 271.9 471.9 L 265.5 476.8 L 258 479.9 L 250 481 L 242 479.9 L 234.5 476.8 L 228.1 471.9 L 223.2 465.5 L 220.1 458 L 219 450 L 220.1 442 L 223.2 434.5 L 228.1 428.1 L 234.5 423.2 L 242 420.1 L 250 419 L 258 420.1 L 265.5 423.2 L 271.9 428.1 L 276.8 434.5 L 279.9 442 Z",
      "position": {
        "x": 250,
        "y": 450
      },
      "badgeAnchor": {
        "x": 250,
        "y": 450
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "sandbar-hold",
      "name": "Sandbar Hold",
      "regionId": "sunlit-shallows",
      "adjacencies": [
        "emberfloor",
        "shellcove",
        "tidecrest"
      ],
      "shape": "M 281 350 L 279.9 358 L 276.8 365.5 L 271.9 371.9 L 265.5 376.8 L 258 379.9 L 250 381 L 242 379.9 L 234.5 376.8 L 228.1 371.9 L 223.2 365.5 L 220.1 358 L 219 350 L 220.1 342 L 223.2 334.5 L 228.1 328.1 L 234.5 323.2 L 242 320.1 L 250 319 L 258 320.1 L 265.5 323.2 L 271.9 328.1 L 276.8 334.5 L 279.9 342 Z",
      "position": {
        "x": 250,
        "y": 350
      },
      "badgeAnchor": {
        "x": 250,
        "y": 350
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "shellcove",
      "name": "Shellcove",
      "regionId": "sunlit-shallows",
      "adjacencies": [
        "aquadome",
        "brinehaven",
        "pelican-reach",
        "sandbar-hold",
        "tidecrest"
      ],
      "shape": "M 191 300 L 189.9 308 L 186.8 315.5 L 181.9 321.9 L 175.5 326.8 L 168 329.9 L 160 331 L 152 329.9 L 144.5 326.8 L 138.1 321.9 L 133.2 315.5 L 130.1 308 L 129 300 L 130.1 292 L 133.2 284.5 L 138.1 278.1 L 144.5 273.2 L 152 270.1 L 160 269 L 168 270.1 L 175.5 273.2 L 181.9 278.1 L 186.8 284.5 L 189.9 292 Z",
      "position": {
        "x": 160,
        "y": 300
      },
      "badgeAnchor": {
        "x": 160,
        "y": 300
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tidecrest",
      "name": "Tidecrest",
      "regionId": "sunlit-shallows",
      "adjacencies": [
        "brinehaven",
        "buoyhold",
        "kelpgate",
        "sandbar-hold",
        "shellcove"
      ],
      "shape": "M 371 300 L 369.9 308 L 366.8 315.5 L 361.9 321.9 L 355.5 326.8 L 348 329.9 L 340 331 L 332 329.9 L 324.5 326.8 L 318.1 321.9 L 313.2 315.5 L 310.1 308 L 309 300 L 310.1 292 L 313.2 284.5 L 318.1 278.1 L 324.5 273.2 L 332 270.1 L 340 269 L 348 270.1 L 355.5 273.2 L 361.9 278.1 L 366.8 284.5 L 369.9 292 Z",
      "position": {
        "x": 340,
        "y": 300
      },
      "badgeAnchor": {
        "x": 340,
        "y": 300
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "pelican-reach",
      "name": "Pelican Reach",
      "regionId": "sunlit-shallows",
      "adjacencies": [
        "brinehaven",
        "gullwater",
        "saltmeadow",
        "shellcove"
      ],
      "shape": "M 191 200 L 189.9 208 L 186.8 215.5 L 181.9 221.9 L 175.5 226.8 L 168 229.9 L 160 231 L 152 229.9 L 144.5 226.8 L 138.1 221.9 L 133.2 215.5 L 130.1 208 L 129 200 L 130.1 192 L 133.2 184.5 L 138.1 178.1 L 144.5 173.2 L 152 170.1 L 160 169 L 168 170.1 L 175.5 173.2 L 181.9 178.1 L 186.8 184.5 L 189.9 192 Z",
      "position": {
        "x": 160,
        "y": 200
      },
      "badgeAnchor": {
        "x": 160,
        "y": 200
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "brinehaven",
      "name": "Brinehaven",
      "regionId": "sunlit-shallows",
      "adjacencies": [
        "kelpgate",
        "pelican-reach",
        "saltmeadow",
        "shellcove",
        "tidecrest"
      ],
      "shape": "M 281 250 L 279.9 258 L 276.8 265.5 L 271.9 271.9 L 265.5 276.8 L 258 279.9 L 250 281 L 242 279.9 L 234.5 276.8 L 228.1 271.9 L 223.2 265.5 L 220.1 258 L 219 250 L 220.1 242 L 223.2 234.5 L 228.1 228.1 L 234.5 223.2 L 242 220.1 L 250 219 L 258 220.1 L 265.5 223.2 L 271.9 228.1 L 276.8 234.5 L 279.9 242 Z",
      "position": {
        "x": 250,
        "y": 250
      },
      "badgeAnchor": {
        "x": 250,
        "y": 250
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "kelpgate",
      "name": "Kelpgate",
      "regionId": "sunlit-shallows",
      "adjacencies": [
        "brinehaven",
        "driftwood-banks",
        "tidecrest"
      ],
      "shape": "M 371 200 L 369.9 208 L 366.8 215.5 L 361.9 221.9 L 355.5 226.8 L 348 229.9 L 340 231 L 332 229.9 L 324.5 226.8 L 318.1 221.9 L 313.2 215.5 L 310.1 208 L 309 200 L 310.1 192 L 313.2 184.5 L 318.1 178.1 L 324.5 173.2 L 332 170.1 L 340 169 L 348 170.1 L 355.5 173.2 L 361.9 178.1 L 366.8 184.5 L 369.9 192 Z",
      "position": {
        "x": 340,
        "y": 200
      },
      "badgeAnchor": {
        "x": 340,
        "y": 200
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "saltmeadow",
      "name": "Saltmeadow",
      "regionId": "sunlit-shallows",
      "adjacencies": [
        "brinehaven",
        "driftwood-banks",
        "gullwater",
        "pelican-reach"
      ],
      "shape": "M 281 150 L 279.9 158 L 276.8 165.5 L 271.9 171.9 L 265.5 176.8 L 258 179.9 L 250 181 L 242 179.9 L 234.5 176.8 L 228.1 171.9 L 223.2 165.5 L 220.1 158 L 219 150 L 220.1 142 L 223.2 134.5 L 228.1 128.1 L 234.5 123.2 L 242 120.1 L 250 119 L 258 120.1 L 265.5 123.2 L 271.9 128.1 L 276.8 134.5 L 279.9 142 Z",
      "position": {
        "x": 250,
        "y": 150
      },
      "badgeAnchor": {
        "x": 250,
        "y": 150
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "driftwood-banks",
      "name": "Driftwood Banks",
      "regionId": "sunlit-shallows",
      "adjacencies": [
        "blackvent",
        "kelpgate",
        "saltmeadow"
      ],
      "shape": "M 371 100 L 369.9 108 L 366.8 115.5 L 361.9 121.9 L 355.5 126.8 L 348 129.9 L 340 131 L 332 129.9 L 324.5 126.8 L 318.1 121.9 L 313.2 115.5 L 310.1 108 L 309 100 L 310.1 92 L 313.2 84.5 L 318.1 78.1 L 324.5 73.2 L 332 70.1 L 340 69 L 348 70.1 L 355.5 73.2 L 361.9 78.1 L 366.8 84.5 L 369.9 92 Z",
      "position": {
        "x": 340,
        "y": 100
      },
      "badgeAnchor": {
        "x": 340,
        "y": 100
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "gullwater",
      "name": "Gullwater",
      "regionId": "sunlit-shallows",
      "adjacencies": [
        "pelican-reach",
        "saltmeadow",
        "spongebed"
      ],
      "shape": "M 191 100 L 189.9 108 L 186.8 115.5 L 181.9 121.9 L 175.5 126.8 L 168 129.9 L 160 131 L 152 129.9 L 144.5 126.8 L 138.1 121.9 L 133.2 115.5 L 130.1 108 L 129 100 L 130.1 92 L 133.2 84.5 L 138.1 78.1 L 144.5 73.2 L 152 70.1 L 160 69 L 168 70.1 L 175.5 73.2 L 181.9 78.1 L 186.8 84.5 L 189.9 92 Z",
      "position": {
        "x": 160,
        "y": 100
      },
      "badgeAnchor": {
        "x": 160,
        "y": 100
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "seastead",
      "name": "Seastead",
      "regionId": "poseidon-domes",
      "adjacencies": [
        "bathysphere",
        "emberfloor"
      ],
      "shape": "M 191 400 L 189.9 408 L 186.8 415.5 L 181.9 421.9 L 175.5 426.8 L 168 429.9 L 160 431 L 152 429.9 L 144.5 426.8 L 138.1 421.9 L 133.2 415.5 L 130.1 408 L 129 400 L 130.1 392 L 133.2 384.5 L 138.1 378.1 L 144.5 373.2 L 152 370.1 L 160 369 L 168 370.1 L 175.5 373.2 L 181.9 378.1 L 186.8 384.5 L 189.9 392 Z",
      "position": {
        "x": 160,
        "y": 400
      },
      "badgeAnchor": {
        "x": 160,
        "y": 400
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "bathysphere",
      "name": "Bathysphere",
      "regionId": "poseidon-domes",
      "adjacencies": [
        "aquadome",
        "periscope-post",
        "seastead"
      ],
      "shape": "M 101 350 L 99.9 358 L 96.8 365.5 L 91.9 371.9 L 85.5 376.8 L 78 379.9 L 70 381 L 62 379.9 L 54.5 376.8 L 48.1 371.9 L 43.2 365.5 L 40.1 358 L 39 350 L 40.1 342 L 43.2 334.5 L 48.1 328.1 L 54.5 323.2 L 62 320.1 L 70 319 L 78 320.1 L 85.5 323.2 L 91.9 328.1 L 96.8 334.5 L 99.9 342 Z",
      "position": {
        "x": 70,
        "y": 350
      },
      "badgeAnchor": {
        "x": 70,
        "y": 350
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "aquadome",
      "name": "Aquadome",
      "regionId": "poseidon-domes",
      "adjacencies": [
        "bathysphere",
        "shellcove"
      ],
      "shape": "M 101 250 L 99.9 258 L 96.8 265.5 L 91.9 271.9 L 85.5 276.8 L 78 279.9 L 70 281 L 62 279.9 L 54.5 276.8 L 48.1 271.9 L 43.2 265.5 L 40.1 258 L 39 250 L 40.1 242 L 43.2 234.5 L 48.1 228.1 L 54.5 223.2 L 62 220.1 L 70 219 L 78 220.1 L 85.5 223.2 L 91.9 228.1 L 96.8 234.5 L 99.9 242 Z",
      "position": {
        "x": 70,
        "y": 250
      },
      "badgeAnchor": {
        "x": 70,
        "y": 250
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "blackvent",
      "name": "Blackvent",
      "regionId": "abyssal-spires",
      "adjacencies": [
        "driftwood-banks",
        "lanternfish-deep",
        "squidhollow"
      ],
      "shape": "M 461 150 L 459.9 158 L 456.8 165.5 L 451.9 171.9 L 445.5 176.8 L 438 179.9 L 430 181 L 422 179.9 L 414.5 176.8 L 408.1 171.9 L 403.2 165.5 L 400.1 158 L 399 150 L 400.1 142 L 403.2 134.5 L 408.1 128.1 L 414.5 123.2 L 422 120.1 L 430 119 L 438 120.1 L 445.5 123.2 L 451.9 128.1 L 456.8 134.5 L 459.9 142 Z",
      "position": {
        "x": 430,
        "y": 150
      },
      "badgeAnchor": {
        "x": 430,
        "y": 150
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "squidhollow",
      "name": "Squidhollow",
      "regionId": "abyssal-spires",
      "adjacencies": [
        "blackvent",
        "gloomspire",
        "lanternfish-deep",
        "pressure-gate",
        "tidewatch"
      ],
      "shape": "M 551 200 L 549.9 208 L 546.8 215.5 L 541.9 221.9 L 535.5 226.8 L 528 229.9 L 520 231 L 512 229.9 L 504.5 226.8 L 498.1 221.9 L 493.2 215.5 L 490.1 208 L 489 200 L 490.1 192 L 493.2 184.5 L 498.1 178.1 L 504.5 173.2 L 512 170.1 L 520 169 L 528 170.1 L 535.5 173.2 L 541.9 178.1 L 546.8 184.5 L 549.9 192 Z",
      "position": {
        "x": 520,
        "y": 200
      },
      "badgeAnchor": {
        "x": 520,
        "y": 200
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "lanternfish-deep",
      "name": "Lanternfish Deep",
      "regionId": "abyssal-spires",
      "adjacencies": [
        "blackvent",
        "gloomspire",
        "inkwell",
        "squidhollow"
      ],
      "shape": "M 641 50 L 639.9 58 L 636.8 65.5 L 631.9 71.9 L 625.5 76.8 L 618 79.9 L 610 81 L 602 79.9 L 594.5 76.8 L 588.1 71.9 L 583.2 65.5 L 580.1 58 L 579 50 L 580.1 42 L 583.2 34.5 L 588.1 28.1 L 594.5 23.2 L 602 20.1 L 610 19 L 618 20.1 L 625.5 23.2 L 631.9 28.1 L 636.8 34.5 L 639.9 42 Z",
      "position": {
        "x": 610,
        "y": 50
      },
      "badgeAnchor": {
        "x": 610,
        "y": 50
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "gloomspire",
      "name": "Gloomspire",
      "regionId": "abyssal-spires",
      "adjacencies": [
        "inkwell",
        "lanternfish-deep",
        "nightcoral",
        "pressure-gate",
        "squidhollow"
      ],
      "shape": "M 641 150 L 639.9 158 L 636.8 165.5 L 631.9 171.9 L 625.5 176.8 L 618 179.9 L 610 181 L 602 179.9 L 594.5 176.8 L 588.1 171.9 L 583.2 165.5 L 580.1 158 L 579 150 L 580.1 142 L 583.2 134.5 L 588.1 128.1 L 594.5 123.2 L 602 120.1 L 610 119 L 618 120.1 L 625.5 123.2 L 631.9 128.1 L 636.8 134.5 L 639.9 142 Z",
      "position": {
        "x": 610,
        "y": 150
      },
      "badgeAnchor": {
        "x": 610,
        "y": 150
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "pressure-gate",
      "name": "Pressure Gate",
      "regionId": "abyssal-spires",
      "adjacencies": [
        "gloomspire",
        "nightcoral",
        "squidhollow",
        "whalefall"
      ],
      "shape": "M 551 300 L 549.9 308 L 546.8 315.5 L 541.9 321.9 L 535.5 326.8 L 528 329.9 L 520 331 L 512 329.9 L 504.5 326.8 L 498.1 321.9 L 493.2 315.5 L 490.1 308 L 489 300 L 490.1 292 L 493.2 284.5 L 498.1 278.1 L 504.5 273.2 L 512 270.1 L 520 269 L 528 270.1 L 535.5 273.2 L 541.9 278.1 L 546.8 284.5 L 549.9 292 Z",
      "position": {
        "x": 520,
        "y": 300
      },
      "badgeAnchor": {
        "x": 520,
        "y": 300
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nightcoral",
      "name": "Nightcoral",
      "regionId": "abyssal-spires",
      "adjacencies": [
        "fanwall",
        "gloomspire",
        "inkwell",
        "leviathans-rest",
        "pressure-gate",
        "whalefall"
      ],
      "shape": "M 641 250 L 639.9 258 L 636.8 265.5 L 631.9 271.9 L 625.5 276.8 L 618 279.9 L 610 281 L 602 279.9 L 594.5 276.8 L 588.1 271.9 L 583.2 265.5 L 580.1 258 L 579 250 L 580.1 242 L 583.2 234.5 L 588.1 228.1 L 594.5 223.2 L 602 220.1 L 610 219 L 618 220.1 L 625.5 223.2 L 631.9 228.1 L 636.8 234.5 L 639.9 242 Z",
      "position": {
        "x": 610,
        "y": 250
      },
      "badgeAnchor": {
        "x": 610,
        "y": 250
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "inkwell",
      "name": "Inkwell",
      "regionId": "abyssal-spires",
      "adjacencies": [
        "brainreef",
        "fanwall",
        "gloomspire",
        "lanternfish-deep",
        "nightcoral",
        "staghorn"
      ],
      "shape": "M 731 200 L 729.9 208 L 726.8 215.5 L 721.9 221.9 L 715.5 226.8 L 708 229.9 L 700 231 L 692 229.9 L 684.5 226.8 L 678.1 221.9 L 673.2 215.5 L 670.1 208 L 669 200 L 670.1 192 L 673.2 184.5 L 678.1 178.1 L 684.5 173.2 L 692 170.1 L 700 169 L 708 170.1 L 715.5 173.2 L 721.9 178.1 L 726.8 184.5 L 729.9 192 Z",
      "position": {
        "x": 700,
        "y": 200
      },
      "badgeAnchor": {
        "x": 700,
        "y": 200
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "leviathans-rest",
      "name": "Leviathan's Rest",
      "regionId": "leviathan-trench",
      "adjacencies": [
        "fanwall",
        "krakenmaw",
        "nightcoral",
        "whalefall"
      ],
      "shape": "M 641 350 L 639.9 358 L 636.8 365.5 L 631.9 371.9 L 625.5 376.8 L 618 379.9 L 610 381 L 602 379.9 L 594.5 376.8 L 588.1 371.9 L 583.2 365.5 L 580.1 358 L 579 350 L 580.1 342 L 583.2 334.5 L 588.1 328.1 L 594.5 323.2 L 602 320.1 L 610 319 L 618 320.1 L 625.5 323.2 L 631.9 328.1 L 636.8 334.5 L 639.9 342 Z",
      "position": {
        "x": 610,
        "y": 350
      },
      "badgeAnchor": {
        "x": 610,
        "y": 350
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "whalefall",
      "name": "Whalefall",
      "regionId": "leviathan-trench",
      "adjacencies": [
        "greenhouse-dome",
        "hadal-gate",
        "krakenmaw",
        "leviathans-rest",
        "magma-vent",
        "nightcoral",
        "pressure-gate"
      ],
      "shape": "M 551 400 L 549.9 408 L 546.8 415.5 L 541.9 421.9 L 535.5 426.8 L 528 429.9 L 520 431 L 512 429.9 L 504.5 426.8 L 498.1 421.9 L 493.2 415.5 L 490.1 408 L 489 400 L 490.1 392 L 493.2 384.5 L 498.1 378.1 L 504.5 373.2 L 512 370.1 L 520 369 L 528 370.1 L 535.5 373.2 L 541.9 378.1 L 546.8 384.5 L 549.9 392 Z",
      "position": {
        "x": 520,
        "y": 400
      },
      "badgeAnchor": {
        "x": 520,
        "y": 400
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "krakenmaw",
      "name": "Krakenmaw",
      "regionId": "leviathan-trench",
      "adjacencies": [
        "bonefield",
        "hadal-gate",
        "leviathans-rest",
        "siphon-deep",
        "whalefall"
      ],
      "shape": "M 731 400 L 729.9 408 L 726.8 415.5 L 721.9 421.9 L 715.5 426.8 L 708 429.9 L 700 431 L 692 429.9 L 684.5 426.8 L 678.1 421.9 L 673.2 415.5 L 670.1 408 L 669 400 L 670.1 392 L 673.2 384.5 L 678.1 378.1 L 684.5 373.2 L 692 370.1 L 700 369 L 708 370.1 L 715.5 373.2 L 721.9 378.1 L 726.8 384.5 L 729.9 392 Z",
      "position": {
        "x": 700,
        "y": 400
      },
      "badgeAnchor": {
        "x": 700,
        "y": 400
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hadal-gate",
      "name": "Hadal Gate",
      "regionId": "leviathan-trench",
      "adjacencies": [
        "krakenmaw",
        "siphon-deep",
        "whalefall"
      ],
      "shape": "M 641 450 L 639.9 458 L 636.8 465.5 L 631.9 471.9 L 625.5 476.8 L 618 479.9 L 610 481 L 602 479.9 L 594.5 476.8 L 588.1 471.9 L 583.2 465.5 L 580.1 458 L 579 450 L 580.1 442 L 583.2 434.5 L 588.1 428.1 L 594.5 423.2 L 602 420.1 L 610 419 L 618 420.1 L 625.5 423.2 L 631.9 428.1 L 636.8 434.5 L 639.9 442 Z",
      "position": {
        "x": 610,
        "y": 450
      },
      "badgeAnchor": {
        "x": 610,
        "y": 450
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "siphon-deep",
      "name": "Siphon Deep",
      "regionId": "leviathan-trench",
      "adjacencies": [
        "argo-wreck",
        "bonefield",
        "hadal-gate",
        "krakenmaw"
      ],
      "shape": "M 641 550 L 639.9 558 L 636.8 565.5 L 631.9 571.9 L 625.5 576.8 L 618 579.9 L 610 581 L 602 579.9 L 594.5 576.8 L 588.1 571.9 L 583.2 565.5 L 580.1 558 L 579 550 L 580.1 542 L 583.2 534.5 L 588.1 528.1 L 594.5 523.2 L 602 520.1 L 610 519 L 618 520.1 L 625.5 523.2 L 631.9 528.1 L 636.8 534.5 L 639.9 542 Z",
      "position": {
        "x": 610,
        "y": 550
      },
      "badgeAnchor": {
        "x": 610,
        "y": 550
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "bonefield",
      "name": "Bonefield",
      "regionId": "leviathan-trench",
      "adjacencies": [
        "geotherm",
        "krakenmaw",
        "siphon-deep"
      ],
      "shape": "M 731 500 L 729.9 508 L 726.8 515.5 L 721.9 521.9 L 715.5 526.8 L 708 529.9 L 700 531 L 692 529.9 L 684.5 526.8 L 678.1 521.9 L 673.2 515.5 L 670.1 508 L 669 500 L 670.1 492 L 673.2 484.5 L 678.1 478.1 L 684.5 473.2 L 692 470.1 L 700 469 L 708 470.1 L 715.5 473.2 L 721.9 478.1 L 726.8 484.5 L 729.9 492 Z",
      "position": {
        "x": 700,
        "y": 500
      },
      "badgeAnchor": {
        "x": 700,
        "y": 500
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "fanwall",
      "name": "Fanwall",
      "regionId": "staghorn-reach",
      "adjacencies": [
        "clownfish-bay",
        "inkwell",
        "leviathans-rest",
        "nightcoral",
        "staghorn"
      ],
      "shape": "M 731 300 L 729.9 308 L 726.8 315.5 L 721.9 321.9 L 715.5 326.8 L 708 329.9 L 700 331 L 692 329.9 L 684.5 326.8 L 678.1 321.9 L 673.2 315.5 L 670.1 308 L 669 300 L 670.1 292 L 673.2 284.5 L 678.1 278.1 L 684.5 273.2 L 692 270.1 L 700 269 L 708 270.1 L 715.5 273.2 L 721.9 278.1 L 726.8 284.5 L 729.9 292 Z",
      "position": {
        "x": 700,
        "y": 300
      },
      "badgeAnchor": {
        "x": 700,
        "y": 300
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "staghorn",
      "name": "Staghorn",
      "regionId": "staghorn-reach",
      "adjacencies": [
        "anemone-fields",
        "brainreef",
        "clownfish-bay",
        "fanwall",
        "inkwell"
      ],
      "shape": "M 821 250 L 819.9 258 L 816.8 265.5 L 811.9 271.9 L 805.5 276.8 L 798 279.9 L 790 281 L 782 279.9 L 774.5 276.8 L 768.1 271.9 L 763.2 265.5 L 760.1 258 L 759 250 L 760.1 242 L 763.2 234.5 L 768.1 228.1 L 774.5 223.2 L 782 220.1 L 790 219 L 798 220.1 L 805.5 223.2 L 811.9 228.1 L 816.8 234.5 L 819.9 242 Z",
      "position": {
        "x": 790,
        "y": 250
      },
      "badgeAnchor": {
        "x": 790,
        "y": 250
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "brainreef",
      "name": "Brainreef",
      "regionId": "staghorn-reach",
      "adjacencies": [
        "anemone-fields",
        "inkwell",
        "parrotfish-point",
        "staghorn"
      ],
      "shape": "M 821 150 L 819.9 158 L 816.8 165.5 L 811.9 171.9 L 805.5 176.8 L 798 179.9 L 790 181 L 782 179.9 L 774.5 176.8 L 768.1 171.9 L 763.2 165.5 L 760.1 158 L 759 150 L 760.1 142 L 763.2 134.5 L 768.1 128.1 L 774.5 123.2 L 782 120.1 L 790 119 L 798 120.1 L 805.5 123.2 L 811.9 128.1 L 816.8 134.5 L 819.9 142 Z",
      "position": {
        "x": 790,
        "y": 150
      },
      "badgeAnchor": {
        "x": 790,
        "y": 150
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "clownfish-bay",
      "name": "Clownfish Bay",
      "regionId": "staghorn-reach",
      "adjacencies": [
        "anemone-fields",
        "fanwall",
        "seafan-ridge",
        "staghorn",
        "ventside"
      ],
      "shape": "M 821 350 L 819.9 358 L 816.8 365.5 L 811.9 371.9 L 805.5 376.8 L 798 379.9 L 790 381 L 782 379.9 L 774.5 376.8 L 768.1 371.9 L 763.2 365.5 L 760.1 358 L 759 350 L 760.1 342 L 763.2 334.5 L 768.1 328.1 L 774.5 323.2 L 782 320.1 L 790 319 L 798 320.1 L 805.5 323.2 L 811.9 328.1 L 816.8 334.5 L 819.9 342 Z",
      "position": {
        "x": 790,
        "y": 350
      },
      "badgeAnchor": {
        "x": 790,
        "y": 350
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "lagoon-throne",
      "name": "Lagoon Throne",
      "regionId": "coral-dominion",
      "adjacencies": [
        "anemone-fields",
        "mantle-reef",
        "parrotfish-point",
        "spongebed",
        "urchin-march"
      ],
      "shape": "M 1001 250 L 999.9 258 L 996.8 265.5 L 991.9 271.9 L 985.5 276.8 L 978 279.9 L 970 281 L 962 279.9 L 954.5 276.8 L 948.1 271.9 L 943.2 265.5 L 940.1 258 L 939 250 L 940.1 242 L 943.2 234.5 L 948.1 228.1 L 954.5 223.2 L 962 220.1 L 970 219 L 978 220.1 L 985.5 223.2 L 991.9 228.1 L 996.8 234.5 L 999.9 242 Z",
      "position": {
        "x": 970,
        "y": 250
      },
      "badgeAnchor": {
        "x": 970,
        "y": 250
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "parrotfish-point",
      "name": "Parrotfish Point",
      "regionId": "coral-dominion",
      "adjacencies": [
        "anemone-fields",
        "brainreef",
        "lagoon-throne",
        "polyp-gardens",
        "urchin-march"
      ],
      "shape": "M 911 200 L 909.9 208 L 906.8 215.5 L 901.9 221.9 L 895.5 226.8 L 888 229.9 L 880 231 L 872 229.9 L 864.5 226.8 L 858.1 221.9 L 853.2 215.5 L 850.1 208 L 849 200 L 850.1 192 L 853.2 184.5 L 858.1 178.1 L 864.5 173.2 L 872 170.1 L 880 169 L 888 170.1 L 895.5 173.2 L 901.9 178.1 L 906.8 184.5 L 909.9 192 Z",
      "position": {
        "x": 880,
        "y": 200
      },
      "badgeAnchor": {
        "x": 880,
        "y": 200
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "anemone-fields",
      "name": "Anemone Fields",
      "regionId": "staghorn-reach",
      "adjacencies": [
        "brainreef",
        "clownfish-bay",
        "lagoon-throne",
        "parrotfish-point",
        "periscope-post",
        "seafan-ridge",
        "staghorn"
      ],
      "shape": "M 911 300 L 909.9 308 L 906.8 315.5 L 901.9 321.9 L 895.5 326.8 L 888 329.9 L 880 331 L 872 329.9 L 864.5 326.8 L 858.1 321.9 L 853.2 315.5 L 850.1 308 L 849 300 L 850.1 292 L 853.2 284.5 L 858.1 278.1 L 864.5 273.2 L 872 270.1 L 880 269 L 888 270.1 L 895.5 273.2 L 901.9 278.1 L 906.8 284.5 L 909.9 292 Z",
      "position": {
        "x": 880,
        "y": 300
      },
      "badgeAnchor": {
        "x": 880,
        "y": 300
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "urchin-march",
      "name": "Urchin March",
      "regionId": "coral-dominion",
      "adjacencies": [
        "lagoon-throne",
        "parrotfish-point",
        "polyp-gardens",
        "spongebed"
      ],
      "shape": "M 1001 150 L 999.9 158 L 996.8 165.5 L 991.9 171.9 L 985.5 176.8 L 978 179.9 L 970 181 L 962 179.9 L 954.5 176.8 L 948.1 171.9 L 943.2 165.5 L 940.1 158 L 939 150 L 940.1 142 L 943.2 134.5 L 948.1 128.1 L 954.5 123.2 L 962 120.1 L 970 119 L 978 120.1 L 985.5 123.2 L 991.9 128.1 L 996.8 134.5 L 999.9 142 Z",
      "position": {
        "x": 970,
        "y": 150
      },
      "badgeAnchor": {
        "x": 970,
        "y": 150
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "seafan-ridge",
      "name": "Seafan Ridge",
      "regionId": "staghorn-reach",
      "adjacencies": [
        "anemone-fields",
        "clownfish-bay",
        "pearlbed"
      ],
      "shape": "M 911 400 L 909.9 408 L 906.8 415.5 L 901.9 421.9 L 895.5 426.8 L 888 429.9 L 880 431 L 872 429.9 L 864.5 426.8 L 858.1 421.9 L 853.2 415.5 L 850.1 408 L 849 400 L 850.1 392 L 853.2 384.5 L 858.1 378.1 L 864.5 373.2 L 872 370.1 L 880 369 L 888 370.1 L 895.5 373.2 L 901.9 378.1 L 906.8 384.5 L 909.9 392 Z",
      "position": {
        "x": 880,
        "y": 400
      },
      "badgeAnchor": {
        "x": 880,
        "y": 400
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "polyp-gardens",
      "name": "Polyp Gardens",
      "regionId": "coral-dominion",
      "adjacencies": [
        "parrotfish-point",
        "spongebed",
        "urchin-march"
      ],
      "shape": "M 911 100 L 909.9 108 L 906.8 115.5 L 901.9 121.9 L 895.5 126.8 L 888 129.9 L 880 131 L 872 129.9 L 864.5 126.8 L 858.1 121.9 L 853.2 115.5 L 850.1 108 L 849 100 L 850.1 92 L 853.2 84.5 L 858.1 78.1 L 864.5 73.2 L 872 70.1 L 880 69 L 888 70.1 L 895.5 73.2 L 901.9 78.1 L 906.8 84.5 L 909.9 92 Z",
      "position": {
        "x": 880,
        "y": 100
      },
      "badgeAnchor": {
        "x": 880,
        "y": 100
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "spongebed",
      "name": "Spongebed",
      "regionId": "coral-dominion",
      "adjacencies": [
        "gullwater",
        "lagoon-throne",
        "mantle-reef",
        "polyp-gardens",
        "urchin-march"
      ],
      "shape": "M 1091 100 L 1089.9 108 L 1086.8 115.5 L 1081.9 121.9 L 1075.5 126.8 L 1068 129.9 L 1060 131 L 1052 129.9 L 1044.5 126.8 L 1038.1 121.9 L 1033.2 115.5 L 1030.1 108 L 1029 100 L 1030.1 92 L 1033.2 84.5 L 1038.1 78.1 L 1044.5 73.2 L 1052 70.1 L 1060 69 L 1068 70.1 L 1075.5 73.2 L 1081.9 78.1 L 1086.8 84.5 L 1089.9 92 Z",
      "position": {
        "x": 1060,
        "y": 100
      },
      "badgeAnchor": {
        "x": 1060,
        "y": 100
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mantle-reef",
      "name": "Mantle Reef",
      "regionId": "coral-dominion",
      "adjacencies": [
        "lagoon-throne",
        "periscope-post",
        "spongebed"
      ],
      "shape": "M 1091 300 L 1089.9 308 L 1086.8 315.5 L 1081.9 321.9 L 1075.5 326.8 L 1068 329.9 L 1060 331 L 1052 329.9 L 1044.5 326.8 L 1038.1 321.9 L 1033.2 315.5 L 1030.1 308 L 1029 300 L 1030.1 292 L 1033.2 284.5 L 1038.1 278.1 L 1044.5 273.2 L 1052 270.1 L 1060 269 L 1068 270.1 L 1075.5 273.2 L 1081.9 278.1 L 1086.8 284.5 L 1089.9 292 Z",
      "position": {
        "x": 1060,
        "y": 300
      },
      "badgeAnchor": {
        "x": 1060,
        "y": 300
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "pearlbed",
      "name": "Pearlbed",
      "regionId": "pearl-atolls",
      "adjacencies": [
        "nacre-isle",
        "oyster-crown",
        "seafan-ridge"
      ],
      "shape": "M 1001 450 L 999.9 458 L 996.8 465.5 L 991.9 471.9 L 985.5 476.8 L 978 479.9 L 970 481 L 962 479.9 L 954.5 476.8 L 948.1 471.9 L 943.2 465.5 L 940.1 458 L 939 450 L 940.1 442 L 943.2 434.5 L 948.1 428.1 L 954.5 423.2 L 962 420.1 L 970 419 L 978 420.1 L 985.5 423.2 L 991.9 428.1 L 996.8 434.5 L 999.9 442 Z",
      "position": {
        "x": 970,
        "y": 450
      },
      "badgeAnchor": {
        "x": 970,
        "y": 450
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "oyster-crown",
      "name": "Oyster Crown",
      "regionId": "pearl-atolls",
      "adjacencies": [
        "moonshell",
        "nacre-isle",
        "pearlbed",
        "sonar-spire"
      ],
      "shape": "M 1091 500 L 1089.9 508 L 1086.8 515.5 L 1081.9 521.9 L 1075.5 526.8 L 1068 529.9 L 1060 531 L 1052 529.9 L 1044.5 526.8 L 1038.1 521.9 L 1033.2 515.5 L 1030.1 508 L 1029 500 L 1030.1 492 L 1033.2 484.5 L 1038.1 478.1 L 1044.5 473.2 L 1052 470.1 L 1060 469 L 1068 470.1 L 1075.5 473.2 L 1081.9 478.1 L 1086.8 484.5 L 1089.9 492 Z",
      "position": {
        "x": 1060,
        "y": 500
      },
      "badgeAnchor": {
        "x": 1060,
        "y": 500
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nacre-isle",
      "name": "Nacre Isle",
      "regionId": "pearl-atolls",
      "adjacencies": [
        "hotspring",
        "moonshell",
        "oyster-crown",
        "pearlbed"
      ],
      "shape": "M 1001 550 L 999.9 558 L 996.8 565.5 L 991.9 571.9 L 985.5 576.8 L 978 579.9 L 970 581 L 962 579.9 L 954.5 576.8 L 948.1 571.9 L 943.2 565.5 L 940.1 558 L 939 550 L 940.1 542 L 943.2 534.5 L 948.1 528.1 L 954.5 523.2 L 962 520.1 L 970 519 L 978 520.1 L 985.5 523.2 L 991.9 528.1 L 996.8 534.5 L 999.9 542 Z",
      "position": {
        "x": 970,
        "y": 550
      },
      "badgeAnchor": {
        "x": 970,
        "y": 550
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "moonshell",
      "name": "Moonshell",
      "regionId": "pearl-atolls",
      "adjacencies": [
        "nacre-isle",
        "oyster-crown"
      ],
      "shape": "M 1091 600 L 1089.9 608 L 1086.8 615.5 L 1081.9 621.9 L 1075.5 626.8 L 1068 629.9 L 1060 631 L 1052 629.9 L 1044.5 626.8 L 1038.1 621.9 L 1033.2 615.5 L 1030.1 608 L 1029 600 L 1030.1 592 L 1033.2 584.5 L 1038.1 578.1 L 1044.5 573.2 L 1052 570.1 L 1060 569 L 1068 570.1 L 1075.5 573.2 L 1081.9 578.1 L 1086.8 584.5 L 1089.9 592 Z",
      "position": {
        "x": 1060,
        "y": 600
      },
      "badgeAnchor": {
        "x": 1060,
        "y": 600
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "greenhouse-dome",
      "name": "Greenhouse Dome",
      "regionId": "kelp-farms",
      "adjacencies": [
        "algae-works",
        "whalefall"
      ],
      "shape": "M 551 500 L 549.9 508 L 546.8 515.5 L 541.9 521.9 L 535.5 526.8 L 528 529.9 L 520 531 L 512 529.9 L 504.5 526.8 L 498.1 521.9 L 493.2 515.5 L 490.1 508 L 489 500 L 490.1 492 L 493.2 484.5 L 498.1 478.1 L 504.5 473.2 L 512 470.1 L 520 469 L 528 470.1 L 535.5 473.2 L 541.9 478.1 L 546.8 484.5 L 549.9 492 Z",
      "position": {
        "x": 520,
        "y": 500
      },
      "badgeAnchor": {
        "x": 520,
        "y": 500
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "algae-works",
      "name": "Algae Works",
      "regionId": "kelp-farms",
      "adjacencies": [
        "greenhouse-dome",
        "magma-vent"
      ],
      "shape": "M 461 550 L 459.9 558 L 456.8 565.5 L 451.9 571.9 L 445.5 576.8 L 438 579.9 L 430 581 L 422 579.9 L 414.5 576.8 L 408.1 571.9 L 403.2 565.5 L 400.1 558 L 399 550 L 400.1 542 L 403.2 534.5 L 408.1 528.1 L 414.5 523.2 L 422 520.1 L 430 519 L 438 520.1 L 445.5 523.2 L 451.9 528.1 L 456.8 534.5 L 459.9 542 Z",
      "position": {
        "x": 430,
        "y": 550
      },
      "badgeAnchor": {
        "x": 430,
        "y": 550
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hullbreaker",
      "name": "Hullbreaker",
      "regionId": "iron-deeps",
      "adjacencies": [
        "ballast-hold",
        "hotspring"
      ],
      "shape": "M 911 710 L 909.9 718 L 906.8 725.5 L 901.9 731.9 L 895.5 736.8 L 888 739.9 L 880 741 L 872 739.9 L 864.5 736.8 L 858.1 731.9 L 853.2 725.5 L 850.1 718 L 849 710 L 850.1 702 L 853.2 694.5 L 858.1 688.1 L 864.5 683.2 L 872 680.1 L 880 679 L 888 680.1 L 895.5 683.2 L 901.9 688.1 L 906.8 694.5 L 909.9 702 Z",
      "position": {
        "x": 880,
        "y": 710
      },
      "badgeAnchor": {
        "x": 880,
        "y": 710
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "beacon-deep",
      "name": "Beacon Deep",
      "regionId": "tidewatch-stations",
      "adjacencies": [
        "buoyhold",
        "magma-vent"
      ],
      "shape": "M 371 400 L 369.9 408 L 366.8 415.5 L 361.9 421.9 L 355.5 426.8 L 348 429.9 L 340 431 L 332 429.9 L 324.5 426.8 L 318.1 421.9 L 313.2 415.5 L 310.1 408 L 309 400 L 310.1 392 L 313.2 384.5 L 318.1 378.1 L 324.5 373.2 L 332 370.1 L 340 369 L 348 370.1 L 355.5 373.2 L 361.9 378.1 L 366.8 384.5 L 369.9 392 Z",
      "position": {
        "x": 340,
        "y": 400
      },
      "badgeAnchor": {
        "x": 340,
        "y": 400
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "buoyhold",
      "name": "Buoyhold",
      "regionId": "tidewatch-stations",
      "adjacencies": [
        "beacon-deep",
        "tidecrest",
        "tidewatch"
      ],
      "shape": "M 461 350 L 459.9 358 L 456.8 365.5 L 451.9 371.9 L 445.5 376.8 L 438 379.9 L 430 381 L 422 379.9 L 414.5 376.8 L 408.1 371.9 L 403.2 365.5 L 400.1 358 L 399 350 L 400.1 342 L 403.2 334.5 L 408.1 328.1 L 414.5 323.2 L 422 320.1 L 430 319 L 438 320.1 L 445.5 323.2 L 451.9 328.1 L 456.8 334.5 L 459.9 342 Z",
      "position": {
        "x": 430,
        "y": 350
      },
      "badgeAnchor": {
        "x": 430,
        "y": 350
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tidewatch",
      "name": "Tidewatch",
      "regionId": "tidewatch-stations",
      "adjacencies": [
        "buoyhold",
        "squidhollow"
      ],
      "shape": "M 461 250 L 459.9 258 L 456.8 265.5 L 451.9 271.9 L 445.5 276.8 L 438 279.9 L 430 281 L 422 279.9 L 414.5 276.8 L 408.1 271.9 L 403.2 265.5 L 400.1 258 L 399 250 L 400.1 242 L 403.2 234.5 L 408.1 228.1 L 414.5 223.2 L 422 220.1 L 430 219 L 438 220.1 L 445.5 223.2 L 451.9 228.1 L 456.8 234.5 L 459.9 242 Z",
      "position": {
        "x": 430,
        "y": 250
      },
      "badgeAnchor": {
        "x": 430,
        "y": 250
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ventside",
      "name": "Ventside",
      "regionId": "thermal-habitats",
      "adjacencies": [
        "clownfish-bay",
        "geotherm"
      ],
      "shape": "M 821 450 L 819.9 458 L 816.8 465.5 L 811.9 471.9 L 805.5 476.8 L 798 479.9 L 790 481 L 782 479.9 L 774.5 476.8 L 768.1 471.9 L 763.2 465.5 L 760.1 458 L 759 450 L 760.1 442 L 763.2 434.5 L 768.1 428.1 L 774.5 423.2 L 782 420.1 L 790 419 L 798 420.1 L 805.5 423.2 L 811.9 428.1 L 816.8 434.5 L 819.9 442 Z",
      "position": {
        "x": 790,
        "y": 450
      },
      "badgeAnchor": {
        "x": 790,
        "y": 450
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "geotherm",
      "name": "Geotherm",
      "regionId": "thermal-habitats",
      "adjacencies": [
        "bonefield",
        "hotspring",
        "ventside"
      ],
      "shape": "M 821 550 L 819.9 558 L 816.8 565.5 L 811.9 571.9 L 805.5 576.8 L 798 579.9 L 790 581 L 782 579.9 L 774.5 576.8 L 768.1 571.9 L 763.2 565.5 L 760.1 558 L 759 550 L 760.1 542 L 763.2 534.5 L 768.1 528.1 L 774.5 523.2 L 782 520.1 L 790 519 L 798 520.1 L 805.5 523.2 L 811.9 528.1 L 816.8 534.5 L 819.9 542 Z",
      "position": {
        "x": 790,
        "y": 550
      },
      "badgeAnchor": {
        "x": 790,
        "y": 550
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hotspring",
      "name": "Hotspring",
      "regionId": "thermal-habitats",
      "adjacencies": [
        "geotherm",
        "hullbreaker",
        "nacre-isle"
      ],
      "shape": "M 911 600 L 909.9 608 L 906.8 615.5 L 901.9 621.9 L 895.5 626.8 L 888 629.9 L 880 631 L 872 629.9 L 864.5 626.8 L 858.1 621.9 L 853.2 615.5 L 850.1 608 L 849 600 L 850.1 592 L 853.2 584.5 L 858.1 578.1 L 864.5 573.2 L 872 570.1 L 880 569 L 888 570.1 L 895.5 573.2 L 901.9 578.1 L 906.8 584.5 L 909.9 592 Z",
      "position": {
        "x": 880,
        "y": 600
      },
      "badgeAnchor": {
        "x": 880,
        "y": 600
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "sonar-spire",
      "name": "Sonar Spire",
      "regionId": "sonar-outposts",
      "adjacencies": [
        "oyster-crown",
        "periscope-post"
      ],
      "shape": "M 1091 400 L 1089.9 408 L 1086.8 415.5 L 1081.9 421.9 L 1075.5 426.8 L 1068 429.9 L 1060 431 L 1052 429.9 L 1044.5 426.8 L 1038.1 421.9 L 1033.2 415.5 L 1030.1 408 L 1029 400 L 1030.1 392 L 1033.2 384.5 L 1038.1 378.1 L 1044.5 373.2 L 1052 370.1 L 1060 369 L 1068 370.1 L 1075.5 373.2 L 1081.9 378.1 L 1086.8 384.5 L 1089.9 392 Z",
      "position": {
        "x": 1060,
        "y": 400
      },
      "badgeAnchor": {
        "x": 1060,
        "y": 400
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "periscope-post",
      "name": "Periscope Post",
      "regionId": "sonar-outposts",
      "adjacencies": [
        "anemone-fields",
        "bathysphere",
        "mantle-reef",
        "sonar-spire"
      ],
      "shape": "M 1001 350 L 999.9 358 L 996.8 365.5 L 991.9 371.9 L 985.5 376.8 L 978 379.9 L 970 381 L 962 379.9 L 954.5 376.8 L 948.1 371.9 L 943.2 365.5 L 940.1 358 L 939 350 L 940.1 342 L 943.2 334.5 L 948.1 328.1 L 954.5 323.2 L 962 320.1 L 970 319 L 978 320.1 L 985.5 323.2 L 991.9 328.1 L 996.8 334.5 L 999.9 342 Z",
      "position": {
        "x": 970,
        "y": 350
      },
      "badgeAnchor": {
        "x": 970,
        "y": 350
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "keel-trench",
      "name": "Keel Trench",
      "regionId": "iron-deeps",
      "adjacencies": [
        "anchor-yard",
        "argo-wreck"
      ],
      "shape": "M 506 710 L 504.9 718 L 501.8 725.5 L 496.9 731.9 L 490.5 736.8 L 483 739.9 L 475 741 L 467 739.9 L 459.5 736.8 L 453.1 731.9 L 448.2 725.5 L 445.1 718 L 444 710 L 445.1 702 L 448.2 694.5 L 453.1 688.1 L 459.5 683.2 L 467 680.1 L 475 679 L 483 680.1 L 490.5 683.2 L 496.9 688.1 L 501.8 694.5 L 504.9 702 Z",
      "position": {
        "x": 475,
        "y": 710
      },
      "badgeAnchor": {
        "x": 475,
        "y": 710
      },
      "ownerId": "",
      "armies": 0
    }
  ],
  "geometryVersion": "v1-01e300ef-ec70e2c5",
  "seaRoutes": [
    {
      "aId": "anchor-yard",
      "bId": "keel-trench",
      "from": {
        "x": 371,
        "y": 710
      },
      "to": {
        "x": 444,
        "y": 710
      }
    },
    {
      "aId": "anchor-yard",
      "bId": "smokestack",
      "from": {
        "x": 340,
        "y": 679
      },
      "to": {
        "x": 340,
        "y": 631
      }
    },
    {
      "aId": "ballast-hold",
      "bId": "argo-wreck",
      "from": {
        "x": 714,
        "y": 710
      },
      "to": {
        "x": 641,
        "y": 710
      }
    },
    {
      "aId": "ballast-hold",
      "bId": "hullbreaker",
      "from": {
        "x": 776,
        "y": 710
      },
      "to": {
        "x": 849,
        "y": 710
      }
    },
    {
      "aId": "argo-wreck",
      "bId": "keel-trench",
      "from": {
        "x": 579,
        "y": 710
      },
      "to": {
        "x": 506,
        "y": 710
      }
    },
    {
      "aId": "argo-wreck",
      "bId": "siphon-deep",
      "from": {
        "x": 610,
        "y": 679
      },
      "to": {
        "x": 610,
        "y": 581
      }
    },
    {
      "aId": "smokestack",
      "bId": "basalt-run",
      "from": {
        "x": 313.2,
        "y": 584.5
      },
      "to": {
        "x": 276.8,
        "y": 565.5
      }
    },
    {
      "aId": "smokestack",
      "bId": "magma-vent",
      "from": {
        "x": 340,
        "y": 569
      },
      "to": {
        "x": 340,
        "y": 531
      }
    },
    {
      "aId": "basalt-run",
      "bId": "emberfloor",
      "from": {
        "x": 250,
        "y": 519
      },
      "to": {
        "x": 250,
        "y": 481
      }
    },
    {
      "aId": "basalt-run",
      "bId": "magma-vent",
      "from": {
        "x": 276.8,
        "y": 534.5
      },
      "to": {
        "x": 313.2,
        "y": 515.5
      }
    },
    {
      "aId": "magma-vent",
      "bId": "algae-works",
      "from": {
        "x": 366.8,
        "y": 515.5
      },
      "to": {
        "x": 403.2,
        "y": 534.5
      }
    },
    {
      "aId": "magma-vent",
      "bId": "beacon-deep",
      "from": {
        "x": 340,
        "y": 469
      },
      "to": {
        "x": 340,
        "y": 431
      }
    },
    {
      "aId": "magma-vent",
      "bId": "emberfloor",
      "from": {
        "x": 313.2,
        "y": 484.5
      },
      "to": {
        "x": 276.8,
        "y": 465.5
      }
    },
    {
      "aId": "magma-vent",
      "bId": "whalefall",
      "from": {
        "x": 366.8,
        "y": 484.5
      },
      "to": {
        "x": 493.2,
        "y": 415.5
      }
    },
    {
      "aId": "emberfloor",
      "bId": "sandbar-hold",
      "from": {
        "x": 250,
        "y": 419
      },
      "to": {
        "x": 250,
        "y": 381
      }
    },
    {
      "aId": "emberfloor",
      "bId": "seastead",
      "from": {
        "x": 223.2,
        "y": 434.5
      },
      "to": {
        "x": 186.8,
        "y": 415.5
      }
    },
    {
      "aId": "sandbar-hold",
      "bId": "shellcove",
      "from": {
        "x": 223.2,
        "y": 334.5
      },
      "to": {
        "x": 186.8,
        "y": 315.5
      }
    },
    {
      "aId": "sandbar-hold",
      "bId": "tidecrest",
      "from": {
        "x": 276.8,
        "y": 334.5
      },
      "to": {
        "x": 313.2,
        "y": 315.5
      }
    },
    {
      "aId": "shellcove",
      "bId": "aquadome",
      "from": {
        "x": 133.2,
        "y": 284.5
      },
      "to": {
        "x": 96.8,
        "y": 265.5
      }
    },
    {
      "aId": "shellcove",
      "bId": "brinehaven",
      "from": {
        "x": 186.8,
        "y": 284.5
      },
      "to": {
        "x": 223.2,
        "y": 265.5
      }
    },
    {
      "aId": "shellcove",
      "bId": "pelican-reach",
      "from": {
        "x": 160,
        "y": 269
      },
      "to": {
        "x": 160,
        "y": 231
      }
    },
    {
      "aId": "shellcove",
      "bId": "tidecrest",
      "from": {
        "x": 191,
        "y": 300
      },
      "to": {
        "x": 309,
        "y": 300
      }
    },
    {
      "aId": "tidecrest",
      "bId": "brinehaven",
      "from": {
        "x": 313.2,
        "y": 284.5
      },
      "to": {
        "x": 276.8,
        "y": 265.5
      }
    },
    {
      "aId": "tidecrest",
      "bId": "buoyhold",
      "from": {
        "x": 366.8,
        "y": 315.5
      },
      "to": {
        "x": 403.2,
        "y": 334.5
      }
    },
    {
      "aId": "tidecrest",
      "bId": "kelpgate",
      "from": {
        "x": 340,
        "y": 269
      },
      "to": {
        "x": 340,
        "y": 231
      }
    },
    {
      "aId": "pelican-reach",
      "bId": "brinehaven",
      "from": {
        "x": 186.8,
        "y": 215.5
      },
      "to": {
        "x": 223.2,
        "y": 234.5
      }
    },
    {
      "aId": "pelican-reach",
      "bId": "gullwater",
      "from": {
        "x": 160,
        "y": 169
      },
      "to": {
        "x": 160,
        "y": 131
      }
    },
    {
      "aId": "pelican-reach",
      "bId": "saltmeadow",
      "from": {
        "x": 186.8,
        "y": 184.5
      },
      "to": {
        "x": 223.2,
        "y": 165.5
      }
    },
    {
      "aId": "brinehaven",
      "bId": "kelpgate",
      "from": {
        "x": 276.8,
        "y": 234.5
      },
      "to": {
        "x": 313.2,
        "y": 215.5
      }
    },
    {
      "aId": "brinehaven",
      "bId": "saltmeadow",
      "from": {
        "x": 250,
        "y": 219
      },
      "to": {
        "x": 250,
        "y": 181
      }
    },
    {
      "aId": "kelpgate",
      "bId": "driftwood-banks",
      "from": {
        "x": 340,
        "y": 169
      },
      "to": {
        "x": 340,
        "y": 131
      }
    },
    {
      "aId": "saltmeadow",
      "bId": "driftwood-banks",
      "from": {
        "x": 276.8,
        "y": 134.5
      },
      "to": {
        "x": 313.2,
        "y": 115.5
      }
    },
    {
      "aId": "saltmeadow",
      "bId": "gullwater",
      "from": {
        "x": 223.2,
        "y": 134.5
      },
      "to": {
        "x": 186.8,
        "y": 115.5
      }
    },
    {
      "aId": "driftwood-banks",
      "bId": "blackvent",
      "from": {
        "x": 366.8,
        "y": 115.5
      },
      "to": {
        "x": 403.2,
        "y": 134.5
      }
    },
    {
      "aId": "seastead",
      "bId": "bathysphere",
      "from": {
        "x": 133.2,
        "y": 384.5
      },
      "to": {
        "x": 96.8,
        "y": 365.5
      }
    },
    {
      "aId": "bathysphere",
      "bId": "aquadome",
      "from": {
        "x": 70,
        "y": 319
      },
      "to": {
        "x": 70,
        "y": 281
      }
    },
    {
      "aId": "blackvent",
      "bId": "lanternfish-deep",
      "from": {
        "x": 456.8,
        "y": 134.5
      },
      "to": {
        "x": 583.2,
        "y": 65.5
      }
    },
    {
      "aId": "blackvent",
      "bId": "squidhollow",
      "from": {
        "x": 456.8,
        "y": 165.5
      },
      "to": {
        "x": 493.2,
        "y": 184.5
      }
    },
    {
      "aId": "squidhollow",
      "bId": "gloomspire",
      "from": {
        "x": 546.8,
        "y": 184.5
      },
      "to": {
        "x": 583.2,
        "y": 165.5
      }
    },
    {
      "aId": "squidhollow",
      "bId": "lanternfish-deep",
      "from": {
        "x": 535.5,
        "y": 173.2
      },
      "to": {
        "x": 594.5,
        "y": 76.8
      }
    },
    {
      "aId": "squidhollow",
      "bId": "pressure-gate",
      "from": {
        "x": 520,
        "y": 231
      },
      "to": {
        "x": 520,
        "y": 269
      }
    },
    {
      "aId": "squidhollow",
      "bId": "tidewatch",
      "from": {
        "x": 493.2,
        "y": 215.5
      },
      "to": {
        "x": 456.8,
        "y": 234.5
      }
    },
    {
      "aId": "lanternfish-deep",
      "bId": "gloomspire",
      "from": {
        "x": 610,
        "y": 81
      },
      "to": {
        "x": 610,
        "y": 119
      }
    },
    {
      "aId": "lanternfish-deep",
      "bId": "inkwell",
      "from": {
        "x": 625.5,
        "y": 76.8
      },
      "to": {
        "x": 684.5,
        "y": 173.2
      }
    },
    {
      "aId": "gloomspire",
      "bId": "inkwell",
      "from": {
        "x": 636.8,
        "y": 165.5
      },
      "to": {
        "x": 673.2,
        "y": 184.5
      }
    },
    {
      "aId": "gloomspire",
      "bId": "nightcoral",
      "from": {
        "x": 610,
        "y": 181
      },
      "to": {
        "x": 610,
        "y": 219
      }
    },
    {
      "aId": "gloomspire",
      "bId": "pressure-gate",
      "from": {
        "x": 594.5,
        "y": 176.8
      },
      "to": {
        "x": 535.5,
        "y": 273.2
      }
    },
    {
      "aId": "pressure-gate",
      "bId": "nightcoral",
      "from": {
        "x": 546.8,
        "y": 284.5
      },
      "to": {
        "x": 583.2,
        "y": 265.5
      }
    },
    {
      "aId": "pressure-gate",
      "bId": "whalefall",
      "from": {
        "x": 520,
        "y": 331
      },
      "to": {
        "x": 520,
        "y": 369
      }
    },
    {
      "aId": "nightcoral",
      "bId": "fanwall",
      "from": {
        "x": 636.8,
        "y": 265.5
      },
      "to": {
        "x": 673.2,
        "y": 284.5
      }
    },
    {
      "aId": "nightcoral",
      "bId": "inkwell",
      "from": {
        "x": 636.8,
        "y": 234.5
      },
      "to": {
        "x": 673.2,
        "y": 215.5
      }
    },
    {
      "aId": "nightcoral",
      "bId": "leviathans-rest",
      "from": {
        "x": 610,
        "y": 281
      },
      "to": {
        "x": 610,
        "y": 319
      }
    },
    {
      "aId": "nightcoral",
      "bId": "whalefall",
      "from": {
        "x": 594.5,
        "y": 276.8
      },
      "to": {
        "x": 535.5,
        "y": 373.2
      }
    },
    {
      "aId": "inkwell",
      "bId": "brainreef",
      "from": {
        "x": 726.8,
        "y": 184.5
      },
      "to": {
        "x": 763.2,
        "y": 165.5
      }
    },
    {
      "aId": "inkwell",
      "bId": "fanwall",
      "from": {
        "x": 700,
        "y": 231
      },
      "to": {
        "x": 700,
        "y": 269
      }
    },
    {
      "aId": "inkwell",
      "bId": "staghorn",
      "from": {
        "x": 726.8,
        "y": 215.5
      },
      "to": {
        "x": 763.2,
        "y": 234.5
      }
    },
    {
      "aId": "leviathans-rest",
      "bId": "fanwall",
      "from": {
        "x": 636.8,
        "y": 334.5
      },
      "to": {
        "x": 673.2,
        "y": 315.5
      }
    },
    {
      "aId": "leviathans-rest",
      "bId": "krakenmaw",
      "from": {
        "x": 636.8,
        "y": 365.5
      },
      "to": {
        "x": 673.2,
        "y": 384.5
      }
    },
    {
      "aId": "leviathans-rest",
      "bId": "whalefall",
      "from": {
        "x": 583.2,
        "y": 365.5
      },
      "to": {
        "x": 546.8,
        "y": 384.5
      }
    },
    {
      "aId": "whalefall",
      "bId": "greenhouse-dome",
      "from": {
        "x": 520,
        "y": 431
      },
      "to": {
        "x": 520,
        "y": 469
      }
    },
    {
      "aId": "whalefall",
      "bId": "hadal-gate",
      "from": {
        "x": 546.8,
        "y": 415.5
      },
      "to": {
        "x": 583.2,
        "y": 434.5
      }
    },
    {
      "aId": "whalefall",
      "bId": "krakenmaw",
      "from": {
        "x": 551,
        "y": 400
      },
      "to": {
        "x": 669,
        "y": 400
      }
    },
    {
      "aId": "krakenmaw",
      "bId": "bonefield",
      "from": {
        "x": 700,
        "y": 431
      },
      "to": {
        "x": 700,
        "y": 469
      }
    },
    {
      "aId": "krakenmaw",
      "bId": "hadal-gate",
      "from": {
        "x": 673.2,
        "y": 415.5
      },
      "to": {
        "x": 636.8,
        "y": 434.5
      }
    },
    {
      "aId": "krakenmaw",
      "bId": "siphon-deep",
      "from": {
        "x": 684.5,
        "y": 426.8
      },
      "to": {
        "x": 625.5,
        "y": 523.2
      }
    },
    {
      "aId": "hadal-gate",
      "bId": "siphon-deep",
      "from": {
        "x": 610,
        "y": 481
      },
      "to": {
        "x": 610,
        "y": 519
      }
    },
    {
      "aId": "siphon-deep",
      "bId": "bonefield",
      "from": {
        "x": 636.8,
        "y": 534.5
      },
      "to": {
        "x": 673.2,
        "y": 515.5
      }
    },
    {
      "aId": "bonefield",
      "bId": "geotherm",
      "from": {
        "x": 726.8,
        "y": 515.5
      },
      "to": {
        "x": 763.2,
        "y": 534.5
      }
    },
    {
      "aId": "fanwall",
      "bId": "clownfish-bay",
      "from": {
        "x": 726.8,
        "y": 315.5
      },
      "to": {
        "x": 763.2,
        "y": 334.5
      }
    },
    {
      "aId": "fanwall",
      "bId": "staghorn",
      "from": {
        "x": 726.8,
        "y": 284.5
      },
      "to": {
        "x": 763.2,
        "y": 265.5
      }
    },
    {
      "aId": "staghorn",
      "bId": "anemone-fields",
      "from": {
        "x": 816.8,
        "y": 265.5
      },
      "to": {
        "x": 853.2,
        "y": 284.5
      }
    },
    {
      "aId": "staghorn",
      "bId": "brainreef",
      "from": {
        "x": 790,
        "y": 219
      },
      "to": {
        "x": 790,
        "y": 181
      }
    },
    {
      "aId": "staghorn",
      "bId": "clownfish-bay",
      "from": {
        "x": 790,
        "y": 281
      },
      "to": {
        "x": 790,
        "y": 319
      }
    },
    {
      "aId": "brainreef",
      "bId": "anemone-fields",
      "from": {
        "x": 805.5,
        "y": 176.8
      },
      "to": {
        "x": 864.5,
        "y": 273.2
      }
    },
    {
      "aId": "brainreef",
      "bId": "parrotfish-point",
      "from": {
        "x": 816.8,
        "y": 165.5
      },
      "to": {
        "x": 853.2,
        "y": 184.5
      }
    },
    {
      "aId": "clownfish-bay",
      "bId": "anemone-fields",
      "from": {
        "x": 816.8,
        "y": 334.5
      },
      "to": {
        "x": 853.2,
        "y": 315.5
      }
    },
    {
      "aId": "clownfish-bay",
      "bId": "seafan-ridge",
      "from": {
        "x": 816.8,
        "y": 365.5
      },
      "to": {
        "x": 853.2,
        "y": 384.5
      }
    },
    {
      "aId": "clownfish-bay",
      "bId": "ventside",
      "from": {
        "x": 790,
        "y": 381
      },
      "to": {
        "x": 790,
        "y": 419
      }
    },
    {
      "aId": "lagoon-throne",
      "bId": "anemone-fields",
      "from": {
        "x": 943.2,
        "y": 265.5
      },
      "to": {
        "x": 906.8,
        "y": 284.5
      }
    },
    {
      "aId": "lagoon-throne",
      "bId": "mantle-reef",
      "from": {
        "x": 996.8,
        "y": 265.5
      },
      "to": {
        "x": 1033.2,
        "y": 284.5
      }
    },
    {
      "aId": "lagoon-throne",
      "bId": "parrotfish-point",
      "from": {
        "x": 943.2,
        "y": 234.5
      },
      "to": {
        "x": 906.8,
        "y": 215.5
      }
    },
    {
      "aId": "lagoon-throne",
      "bId": "spongebed",
      "from": {
        "x": 985.5,
        "y": 223.2
      },
      "to": {
        "x": 1044.5,
        "y": 126.8
      }
    },
    {
      "aId": "lagoon-throne",
      "bId": "urchin-march",
      "from": {
        "x": 970,
        "y": 219
      },
      "to": {
        "x": 970,
        "y": 181
      }
    },
    {
      "aId": "parrotfish-point",
      "bId": "anemone-fields",
      "from": {
        "x": 880,
        "y": 231
      },
      "to": {
        "x": 880,
        "y": 269
      }
    },
    {
      "aId": "parrotfish-point",
      "bId": "polyp-gardens",
      "from": {
        "x": 880,
        "y": 169
      },
      "to": {
        "x": 880,
        "y": 131
      }
    },
    {
      "aId": "parrotfish-point",
      "bId": "urchin-march",
      "from": {
        "x": 906.8,
        "y": 184.5
      },
      "to": {
        "x": 943.2,
        "y": 165.5
      }
    },
    {
      "aId": "anemone-fields",
      "bId": "periscope-post",
      "from": {
        "x": 906.8,
        "y": 315.5
      },
      "to": {
        "x": 943.2,
        "y": 334.5
      }
    },
    {
      "aId": "anemone-fields",
      "bId": "seafan-ridge",
      "from": {
        "x": 880,
        "y": 331
      },
      "to": {
        "x": 880,
        "y": 369
      }
    },
    {
      "aId": "urchin-march",
      "bId": "polyp-gardens",
      "from": {
        "x": 943.2,
        "y": 134.5
      },
      "to": {
        "x": 906.8,
        "y": 115.5
      }
    },
    {
      "aId": "urchin-march",
      "bId": "spongebed",
      "from": {
        "x": 996.8,
        "y": 134.5
      },
      "to": {
        "x": 1033.2,
        "y": 115.5
      }
    },
    {
      "aId": "seafan-ridge",
      "bId": "pearlbed",
      "from": {
        "x": 906.8,
        "y": 415.5
      },
      "to": {
        "x": 943.2,
        "y": 434.5
      }
    },
    {
      "aId": "polyp-gardens",
      "bId": "spongebed",
      "from": {
        "x": 911,
        "y": 100
      },
      "to": {
        "x": 1029,
        "y": 100
      }
    },
    {
      "aId": "spongebed",
      "bId": "mantle-reef",
      "from": {
        "x": 1060,
        "y": 131
      },
      "to": {
        "x": 1060,
        "y": 269
      }
    },
    {
      "aId": "mantle-reef",
      "bId": "periscope-post",
      "from": {
        "x": 1033.2,
        "y": 315.5
      },
      "to": {
        "x": 996.8,
        "y": 334.5
      }
    },
    {
      "aId": "pearlbed",
      "bId": "nacre-isle",
      "from": {
        "x": 970,
        "y": 481
      },
      "to": {
        "x": 970,
        "y": 519
      }
    },
    {
      "aId": "pearlbed",
      "bId": "oyster-crown",
      "from": {
        "x": 996.8,
        "y": 465.5
      },
      "to": {
        "x": 1033.2,
        "y": 484.5
      }
    },
    {
      "aId": "oyster-crown",
      "bId": "moonshell",
      "from": {
        "x": 1060,
        "y": 531
      },
      "to": {
        "x": 1060,
        "y": 569
      }
    },
    {
      "aId": "oyster-crown",
      "bId": "nacre-isle",
      "from": {
        "x": 1033.2,
        "y": 515.5
      },
      "to": {
        "x": 996.8,
        "y": 534.5
      }
    },
    {
      "aId": "oyster-crown",
      "bId": "sonar-spire",
      "from": {
        "x": 1060,
        "y": 469
      },
      "to": {
        "x": 1060,
        "y": 431
      }
    },
    {
      "aId": "nacre-isle",
      "bId": "hotspring",
      "from": {
        "x": 943.2,
        "y": 565.5
      },
      "to": {
        "x": 906.8,
        "y": 584.5
      }
    },
    {
      "aId": "nacre-isle",
      "bId": "moonshell",
      "from": {
        "x": 996.8,
        "y": 565.5
      },
      "to": {
        "x": 1033.2,
        "y": 584.5
      }
    },
    {
      "aId": "greenhouse-dome",
      "bId": "algae-works",
      "from": {
        "x": 493.2,
        "y": 515.5
      },
      "to": {
        "x": 456.8,
        "y": 534.5
      }
    },
    {
      "aId": "hullbreaker",
      "bId": "hotspring",
      "from": {
        "x": 880,
        "y": 679
      },
      "to": {
        "x": 880,
        "y": 631
      }
    },
    {
      "aId": "beacon-deep",
      "bId": "buoyhold",
      "from": {
        "x": 366.8,
        "y": 384.5
      },
      "to": {
        "x": 403.2,
        "y": 365.5
      }
    },
    {
      "aId": "buoyhold",
      "bId": "tidewatch",
      "from": {
        "x": 430,
        "y": 319
      },
      "to": {
        "x": 430,
        "y": 281
      }
    },
    {
      "aId": "ventside",
      "bId": "geotherm",
      "from": {
        "x": 790,
        "y": 481
      },
      "to": {
        "x": 790,
        "y": 519
      }
    },
    {
      "aId": "geotherm",
      "bId": "hotspring",
      "from": {
        "x": 816.8,
        "y": 565.5
      },
      "to": {
        "x": 853.2,
        "y": 584.5
      }
    },
    {
      "aId": "sonar-spire",
      "bId": "periscope-post",
      "from": {
        "x": 1033.2,
        "y": 384.5
      },
      "to": {
        "x": 996.8,
        "y": 365.5
      }
    },
    {
      "aId": "periscope-post",
      "bId": "__edge_right_bathysphere",
      "from": {
        "x": 1001,
        "y": 350
      },
      "to": {
        "x": 1150,
        "y": 350
      }
    },
    {
      "aId": "__edge_left_periscope-post",
      "bId": "bathysphere",
      "from": {
        "x": 0,
        "y": 350
      },
      "to": {
        "x": 39,
        "y": 350
      }
    },
    {
      "aId": "spongebed",
      "bId": "__edge_right_gullwater",
      "from": {
        "x": 1091,
        "y": 100
      },
      "to": {
        "x": 1150,
        "y": 100
      }
    },
    {
      "aId": "__edge_left_spongebed",
      "bId": "gullwater",
      "from": {
        "x": 0,
        "y": 100
      },
      "to": {
        "x": 129,
        "y": 100
      }
    }
  ]
}
